/**
 * Ring builder Step 2 — Nivoda diamond list (via backend proxy).
 */
window.RingBuilderDiamonds = (function () {
  var NIVODA_LIVE_PROXY_BASE = "https://diamondsforeveryone.com.au/apps/nivoda";
  var NIVODA_LIVE_DIAMONDS_URL = "https://diamondsforeveryone.com.au/apps/nivoda/diamonds";
  var STORAGE_KEY = "ringBuilderSelectedDiamond";
  var VIEW_STORAGE_KEY = "ringBuilderDiamondView";
  var FILTER_STORAGE_KEY = "dfeDiamondBrowseFilters";
  var FLOW_KEY = "ringBuilderFlow";
  var FLOW_DIAMOND_FIRST = "diamond-first";
  var DEFAULT_FETCH_LIMIT = 50;
  var MIN_FETCH_LIMIT = 8;
  var MAX_FETCH_LIMIT = 100;
  var LOAD_MORE_LABEL = "Load More";
  var FILTER_RELOAD_DEBOUNCE_MS = 250;
  var state = {
    apiOffset: 0,
    totalCount: 0,
    lastPageRawCount: 0,
    lastFetchLimit: DEFAULT_FETCH_LIMIT,
    clientPriceFilter: false,
    priceRangeComplete: false,
    priceSkipPages: 0,
    loading: false,
    pendingReload: false,
    reloadTimer: null,
    requestId: 0,
    userHasEditedFilters: false,
    items: [],
    viewMode: "grid",
    currentDiamond: null,
    openDiamondId: "",
    pendingSharedOpen: "",
  };

  function parseFetchLimit(value, fallback) {
    var limit = parseInt(value, 10);
    var safeFallback = parseInt(fallback, 10);
    if (!isFinite(safeFallback)) safeFallback = DEFAULT_FETCH_LIMIT;
    if (!isFinite(limit)) return safeFallback;
    if (limit < MIN_FETCH_LIMIT) return MIN_FETCH_LIMIT;
    if (limit > MAX_FETCH_LIMIT) return MAX_FETCH_LIMIT;
    return limit;
  }

  function getFetchLimit(isAppend) {
    var config = getConfig();
    var initialLimit = parseFetchLimit(
      config.initialLimit,
      DEFAULT_FETCH_LIMIT,
    );
    if (isAppend) {
      return parseFetchLimit(config.loadMoreLimit, initialLimit);
    }
    return initialLimit;
  }

  function hasMoreDiamondsToLoad() {
    if (state.clientPriceFilter && state.priceRangeComplete) return false;
    // Staging can cap total_count at the current page boundary. Keep Load More
    // available after a completely full page; an empty/partial next response
    // will then hide it normally.
    if (state.totalCount > 0) {
      return (
        state.apiOffset < state.totalCount ||
        state.lastPageRawCount >= state.lastFetchLimit
      );
    }
    return state.lastPageRawCount >= state.lastFetchLimit;
  }

  function getDisplayTotalCount(shownCount) {
    if (state.clientPriceFilter) {
      return hasMoreDiamondsToLoad() ? 0 : shownCount;
    }
    if (!hasMoreDiamondsToLoad()) {
      return shownCount;
    }
    if (state.totalCount > shownCount) {
      return state.totalCount;
    }
    return 0;
  }

  function formatDiamondCount(value) {
    var count = Number(value || 0);
    if (!isFinite(count) || count < 0) return "0";
    return count.toLocaleString();
  }

  function setLoadMoreVisibility() {
    var root = getRoot();
    if (!root) return;

    var loadMoreWrap = root.querySelector("[data-diamond-load-more-wrap]");
    if (!loadMoreWrap) return;

    var show = state.items.length > 0 && hasMoreDiamondsToLoad();

    loadMoreWrap.hidden = !show;
    loadMoreWrap.style.display = show ? "flex" : "none";
    loadMoreWrap.classList.toggle("is-visible", show);
    loadMoreWrap.setAttribute("aria-hidden", show ? "false" : "true");
  }

  function getRoot() {
    return document.querySelector("[data-ring-builder-diamonds]");
  }

  function getDiamondSearchLayoutElements(root) {
    root = root || getRoot();
    if (!root) return [];

    return [
      root.querySelector(".ring-builder-diamond-types"),
      root.querySelector(".ring-builder-diamonds__filters-wrap"),
      root.querySelector(".ring-builder-diamonds__results-header"),
      root.querySelector(".ring-builder-diamonds__results-actions"),
      root.querySelector(".ring-builder-diamonds__toolbar"),
      root.querySelector(".ring-builder-diamonds__results"),
      root.querySelector(".ring-builder-diamonds__load-more-wrap"),
      root.querySelector(".ring-builder-diamonds__result-meta"),
      root.querySelector("[data-diamond-notice]"),
      root.querySelector("[data-diamond-loading]"),
      root.querySelector("[data-diamond-skeleton]"),
    ].filter(Boolean);
  }

  function isDiamondDetailOpen() {
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return false;
    return detailView.style.display !== "none" && detailView.offsetParent !== null
      ? true
      : detailView.style.display === "block";
  }

  function showDiamondSearchLayout(root) {
    root = root || getRoot();
    if (!root) return;

    root.classList.remove("is-diamond-detail-open");

    var detailView = document.getElementById("DiamondDetailView");
    if (detailView) {
      detailView.style.display = "none";
    }

    getDiamondSearchLayoutElements(root).forEach(function (el) {
      el.style.removeProperty("display");
      if (el.hasAttribute("hidden") && el.matches("[data-diamond-skeleton], [data-diamond-loading], [data-diamond-notice]")) {
        el.hidden = true;
      }
    });

    setLoadMoreVisibility();

    window.requestAnimationFrame(function () {
      var saved = restoreFiltersFromMemory() || getFilters();
      if (saved) applyFiltersToUi(saved);
    });
  }

  function hideDiamondSearchLayout(root) {
    root = root || getRoot();
    if (!root) return;

    root.classList.add("is-diamond-detail-open");

    getDiamondSearchLayoutElements(root).forEach(function (el) {
      el.style.display = "none";
    });
    var skeleton = root.querySelector("[data-diamond-skeleton]");
    var loadingText = root.querySelector("[data-diamond-loading]");
    if (skeleton) skeleton.hidden = true;
    if (loadingText) loadingText.hidden = true;
  }

  function isStandaloneDiamondBrowse() {
    var root = getRoot();
    return !!(root && root.getAttribute("data-standalone-diamonds") === "true");
  }

  function getShopDomain() {
    var root = getRoot();
    if (root && root.getAttribute("data-shop")) {
      return root.getAttribute("data-shop");
    }
    var scoped = document.querySelector("[data-ring-builder-diamonds][data-shop]");
    return scoped ? scoped.getAttribute("data-shop") : "";
  }

  function resolveDevProxyBase() {
    var root = getRoot();
    var container =
      (root && root.closest("[data-nivoda-dev-proxy-base]")) ||
      document.querySelector("[data-nivoda-dev-proxy-base]");
    var base = container ? container.getAttribute("data-nivoda-dev-proxy-base") : "";
    return base ? base.replace(/\/$/, "") : "";
  }

  function usesDirectDevProxy(url) {
    return /^https?:\/\//i.test(url || "");
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function resolveSameOriginProxyUrl(url) {
    var fallback = "/apps/nivoda/diamonds";
    var configured = String(url || "").replace(/\/+$/, "");
    if (!configured) return fallback;
    if (configured.charAt(0) === "/") return configured;
    try {
      var parsed = new URL(configured, window.location.origin);
      if (parsed.pathname && parsed.pathname.indexOf("/apps/nivoda") !== -1) {
        return parsed.pathname.replace(/\/+$/, "") || fallback;
      }
      if (parsed.host === window.location.host) {
        return parsed.pathname.replace(/\/+$/, "") || fallback;
      }
    } catch (e) {}
    return fallback;
  }

  function persistFilters(filters) {
    try {
      sessionStorage.setItem(
        FILTER_STORAGE_KEY,
        JSON.stringify(filters || getFilters()),
      );
    } catch (e) {}
  }

  function readPersistedFilters() {
    try {
      var raw = sessionStorage.getItem(FILTER_STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function restoreFiltersFromMemory() {
    var urlFilters = parseUrlToFilters();
    if (urlFilters) return urlFilters;
    return readPersistedFilters();
  }

  function getDiamondShareId(item) {
    if (!item) return "";
    return String(item.certNumber || item.diamondId || item.offerId || "").trim();
  }

  function diamondMatchesShareId(item, shareId) {
    var id = String(shareId || "").trim().toUpperCase();
    if (!id || !item) return false;
    return [item.certNumber, item.diamondId, item.offerId].some(function (value) {
      return String(value || "").trim().toUpperCase() === id;
    });
  }

  function getSharedDiamondIdFromUrl() {
    try {
      var params = new URL(window.location.href).searchParams;
      return String(
        params.get("diamondId") || params.get("CertNumber") || "",
      ).trim();
    } catch (e) {
      return "";
    }
  }

  function setCertNumberFilter(value) {
    var root = getRoot();
    var certInput = root && root.querySelector("#diamond-filter-cert-number");
    if (certInput) certInput.value = String(value || "").trim();
  }

  function applySharedDiamondToFilters(shareId) {
    var id = String(shareId || "").trim();
    if (!id) return false;
    state.openDiamondId = id;
    state.pendingSharedOpen = id;
    setCertNumberFilter(id);
    return true;
  }

  function buildDiamondShareUrl(shareId) {
    var url = new URL(window.location.href);
    url.search = "";
    url.hash = "";
    url.searchParams.set("diamondId", shareId);
    return url.toString();
  }

  function setOpenDiamondUrl(shareId) {
    state.openDiamondId = String(shareId || "").trim();
    if (!state.openDiamondId) return;
    setCertNumberFilter(state.openDiamondId);
    syncFiltersToUrl(getFilters());
  }

  function clearOpenDiamondUrl() {
    state.openDiamondId = "";
    state.pendingSharedOpen = "";
    state.currentDiamond = null;
    setCertNumberFilter("");
    syncFiltersToUrl(getFilters());
  }

  function copyDiamondShareUrl(shareId) {
    var url = buildDiamondShareUrl(shareId);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url);
    }
    return new Promise(function (resolve, reject) {
      var input = document.createElement("textarea");
      input.value = url;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        resolve();
      } catch (error) {
        reject(error);
      }
      document.body.removeChild(input);
    });
  }

  function setShareButtonCopied(button, copied) {
    if (!button) return;
    var label = button.querySelector("[data-share-diamond-label]");
    button.classList.toggle("is-copied", copied);
    if (label) label.textContent = copied ? "Copied" : "Share";
    button.setAttribute("aria-label", copied ? "Link copied" : "Share this diamond");
  }

  function bindDiamondShareButton(detailView, item) {
    var shareBtn = detailView.querySelector("[data-share-diamond]");
    if (!shareBtn) return;
    var shareId = getDiamondShareId(item);
    shareBtn.hidden = !shareId;
    shareBtn.disabled = !shareId;
    setShareButtonCopied(shareBtn, false);
    var nextBtn = shareBtn.cloneNode(true);
    shareBtn.parentNode.replaceChild(nextBtn, shareBtn);
    if (!shareId) return;
    nextBtn.addEventListener("click", function (event) {
      event.preventDefault();
      copyDiamondShareUrl(shareId)
        .then(function () {
          setShareButtonCopied(nextBtn, true);
          window.clearTimeout(nextBtn._shareCopiedTimer);
          nextBtn._shareCopiedTimer = window.setTimeout(function () {
            setShareButtonCopied(nextBtn, false);
          }, 2000);
        })
        .catch(function () {
          window.prompt("Copy this diamond link:", buildDiamondShareUrl(shareId));
        });
    });
  }

  function pickSharedDiamondFromItems(items, shareId) {
    var list = items || [];
    for (var i = 0; i < list.length; i++) {
      if (diamondMatchesShareId(list[i], shareId)) return list[i];
    }
    return list.length ? list[0] : null;
  }

  function fetchDiamondByShareId(shareId) {
    var id = String(shareId || "").trim();
    if (!id) return Promise.resolve(null);

    var types = ["labgrown", "natural", "labgrown_colour"];

    function request(diamondType) {
      var url = buildProxyUrl(
        {
          cert_number: id,
          diamond_type: diamondType,
          sort: getDefaultDiamondSort(),
        },
        0,
        20,
      );
      return fetch(url)
        .then(parseProxyJsonResponse)
        .then(function (data) {
          return pickSharedDiamondFromItems((data && data.items) || [], id);
        });
    }

    function next(index) {
      if (index >= types.length) return Promise.resolve(null);
      return request(types[index]).then(function (item) {
        if (item) return item;
        return next(index + 1);
      });
    }

    return next(0);
  }

  function maybeOpenSharedDiamond(items) {
    var shareId = state.pendingSharedOpen;
    if (!shareId) return;

    var match = pickSharedDiamondFromItems(items, shareId);
    if (match) {
      state.pendingSharedOpen = "";
      openDiamondPreview(match);
      return;
    }

    fetchDiamondByShareId(shareId).then(function (item) {
      if (item) {
        state.pendingSharedOpen = "";
        openDiamondPreview(item);
        return;
      }
      state.pendingSharedOpen = "";
      state.openDiamondId = "";
      setCertNumberFilter("");
      showDiamondSearchLayout(getRoot());
      setPanelMessage(
        "This diamond is no longer available. Browse the collection below.",
        false,
      );
      loadDiamonds(false);
    });
  }

  function getConfig() {
    var root = getRoot();
    if (!root) return {};
    var proxyUrl =
      root.getAttribute("data-nivoda-proxy-url") ||
      NIVODA_LIVE_DIAMONDS_URL;
    var devBase = resolveDevProxyBase();
    if (devBase) {
      proxyUrl = devBase + "/diamonds";
    } else {
      proxyUrl = resolveSameOriginProxyUrl(proxyUrl);
    }
    proxyUrl = proxyUrl.replace(/\?.*$/, "");
    return {
      proxyUrl: proxyUrl,
      usesDirectDevProxy: usesDirectDevProxy(proxyUrl),
      gridClass:
        root.getAttribute("data-diamond-grid-class") || "col-sm-6 col-lg-3",
      initialLimit: root.getAttribute("data-diamond-initial-limit"),
      loadMoreLimit: root.getAttribute("data-diamond-load-more-limit"),
    };
  }

  function getTableBody() {
    var root = getRoot();
    return root ? root.querySelector("[data-diamond-table-body]") : null;
  }

  function getGrid() {
    var root = getRoot();
    return root ? root.querySelector("[data-diamond-grid]") : null;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getDiamondMediaEmbedSize(mediaContainer) {
    var cssWidth = 0;
    var cssHeight = 0;

    if (mediaContainer) {
      cssWidth = Math.floor(mediaContainer.clientWidth || 0);
      cssHeight = Math.floor(mediaContainer.clientHeight || 0);
    }

    if (cssWidth < 50 || cssHeight < 50) {
      var mediaMain =
        mediaContainer && mediaContainer.closest(".diamond-detail-view__media-main");
      if (mediaMain) {
        var rect = mediaMain.getBoundingClientRect();
        cssWidth = Math.floor(rect.width || mediaMain.clientWidth || 0);
        cssHeight = Math.floor(rect.height || mediaMain.clientHeight || 0);
      }
    }

    var size = Math.max(200, Math.min(cssWidth, cssHeight));
    return { size: size, width: cssWidth, height: cssHeight };
  }

  function resizeNivodaEmbedUrl(url, width, height) {
    if (!url) return url;
    var w = Math.max(200, Math.round(width || 500));
    var h = Math.max(200, Math.round(height || w));
    return String(url).replace(
      /\/(video|image)\/(\d+)\/(\d+)(?=[/?#]|$)/i,
      function (_match, type) {
        return "/" + type + "/" + w + "/" + h;
      }
    );
  }

  function isNivodaLoupeImageUrl(url) {
    return /\/image\/\d+\/\d+/i.test(String(url || ""));
  }

  function isNivodaLoupeVideoUrl(url) {
    return /\/video\/\d+\/\d+/i.test(String(url || ""));
  }

  function isNivodaLoupeEmbedUrl(url) {
    return isNivodaLoupeImageUrl(url) || isNivodaLoupeVideoUrl(url);
  }

  function loupeVideoToImageUrl(videoUrl) {
    return String(videoUrl || "").replace(/\/video\//i, "/image/");
  }

  function getDiamondPlaceholderUrl() {
    if (window.__dfeDiamondPlaceholderUrl) return window.__dfeDiamondPlaceholderUrl;
    var scoped = document.querySelector("[data-diamond-placeholder-url]");
    if (scoped) {
      window.__dfeDiamondPlaceholderUrl =
        scoped.getAttribute("data-diamond-placeholder-url") || "";
      return window.__dfeDiamondPlaceholderUrl;
    }
    var tplImg = document.querySelector(
      "#diamond-card-ub-template .ub-diamond-card__placeholder-icon",
    );
    window.__dfeDiamondPlaceholderUrl = tplImg
      ? tplImg.getAttribute("src") || ""
      : "";
    return window.__dfeDiamondPlaceholderUrl;
  }

  function getSampleDiamondImagesMap() {
    if (window.__dfeSampleDiamondImages) return window.__dfeSampleDiamondImages;
    var el = document.getElementById("ring-builder-sample-diamond-images");
    var map = {};
    if (el) {
      try {
        var raw = String(el.textContent || "").replace(/^\uFEFF/, "").trim();
        map = raw ? JSON.parse(raw) : {};
        if (!map || typeof map !== "object") map = {};
      } catch (e) {
        map = {};
      }
    }
    window.__dfeSampleDiamondImages = map;
    return map;
  }

  function normalizeSampleShapeKey(shape) {
    return String(shape || "")
      .trim()
      .toUpperCase()
      .replace(/_/g, " ")
      .replace(/\s+/g, " ");
  }

  function absoluteMediaUrl(url) {
    var value = String(url || "").trim();
    if (!value) return "";
    if (value.indexOf("//") === 0) return "https:" + value;
    return value;
  }

  function getSampleDiamondImageUrl(shape) {
    var map = getSampleDiamondImagesMap();
    if (!map) return "";
    var key = normalizeSampleShapeKey(shape);
    if (!key) return "";
    if (map[key]) return absoluteMediaUrl(map[key]);

    var base = key.split(" ")[0];
    if (base && map[base]) return absoluteMediaUrl(map[base]);

    // Cushion / radiant variants share a sample photo by family.
    if (key.indexOf("CUSHION") === 0 && map.CUSHION) return absoluteMediaUrl(map.CUSHION);
    if (key.indexOf("RADIANT") === 0 && map.RADIANT) return absoluteMediaUrl(map.RADIANT);
    if ((key.indexOf("EMERALD") === 0 || key === "SQ EMERALD") && map.EMERALD) {
      return absoluteMediaUrl(map.EMERALD);
    }
    return "";
  }

  function setDetailSampleBadge(visible) {
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return;
    var badge = detailView.querySelector("[data-detail-sample-badge]");
    if (badge) badge.hidden = !visible;
  }

  function renderDiamondPlaceholderImage(className, altText) {
    var url = getDiamondPlaceholderUrl();
    if (!url) return "";
    return (
      '<img class="' +
      escapeHtml(className || "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder") +
      '" src="' +
      escapeHtml(url) +
      '" alt="' +
      escapeHtml(altText || "") +
      '">'
    );
  }

  function renderDetailShapeFallback(mediaContainer, item, altText) {
    if (!mediaContainer) return false;

    mediaContainer.removeAttribute("data-embed-width");
    mediaContainer.removeAttribute("data-embed-height");

    var sampleUrl = getSampleDiamondImageUrl(item && item.shape);
    if (sampleUrl) {
      var img = document.createElement("img");
      img.className = "diamond-detail-view__media-img diamond-detail-view__media-img--sample";
      img.alt = altText || "";
      img.src = sampleUrl;
      img.addEventListener("error", function onSampleError() {
        img.removeEventListener("error", onSampleError);
        setDetailSampleBadge(false);
        mediaContainer.innerHTML = renderDiamondPlaceholderImage(
          "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder",
          altText,
        );
      });
      mediaContainer.innerHTML = "";
      mediaContainer.appendChild(img);
      setDetailSampleBadge(true);
      return true;
    }

    setDetailSampleBadge(false);
    mediaContainer.innerHTML = renderDiamondPlaceholderImage(
      "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder",
      altText,
    );
    return !!getDiamondPlaceholderUrl();
  }

  function renderDetailImage(mediaContainer, imageUrl, altText, item) {
    if (!mediaContainer || !imageUrl) return false;

    mediaContainer.removeAttribute("data-embed-width");
    mediaContainer.removeAttribute("data-embed-height");
    setDetailSampleBadge(false);

    var img = document.createElement("img");
    img.className = "diamond-detail-view__media-img";
    img.alt = altText || "";
    img.src = imageUrl;
    img.addEventListener("error", function onImageError() {
      img.removeEventListener("error", onImageError);
      if (item && renderDetailShapeFallback(mediaContainer, item, altText)) return;
      setDetailSampleBadge(false);
      mediaContainer.innerHTML = renderDiamondPlaceholderImage(
        "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder",
        altText,
      );
    });

    mediaContainer.innerHTML = "";
    mediaContainer.appendChild(img);
    return true;
  }

  function renderDetailMediaContent(mediaContainer, mediaUrl, altText, width, height, mediaKind, item) {
    if (!mediaContainer || !mediaUrl) return false;

    var sizedUrl = isNivodaLoupeEmbedUrl(mediaUrl)
      ? resizeNivodaEmbedUrl(mediaUrl, width, height)
      : mediaUrl;
    var wantsImage =
      mediaKind === "image" ||
      isNivodaLoupeImageUrl(sizedUrl) ||
      (!isNivodaLoupeVideoUrl(sizedUrl) && !/\.(mp4|webm|mov)(\?|#|$)/i.test(sizedUrl));

    if (wantsImage) {
      return renderDetailImage(mediaContainer, sizedUrl, altText, item);
    }

    if (/\.(mp4|webm|mov)(\?|#|$)/i.test(sizedUrl)) {
      setDetailSampleBadge(false);
      mediaContainer.removeAttribute("data-embed-width");
      mediaContainer.removeAttribute("data-embed-height");
      mediaContainer.innerHTML =
        '<video src="' +
        escapeHtml(sizedUrl) +
        '" controls autoplay loop playsinline class="diamond-detail-view__media-img"></video>';
      return true;
    }

    if (isNivodaLoupeVideoUrl(sizedUrl)) {
      setDetailSampleBadge(false);
      renderLoupe360Iframe(mediaContainer, sizedUrl, width, height);
      return true;
    }

    return renderDetailImage(mediaContainer, sizedUrl, altText, item);
  }

  function renderLoupe360Iframe(mediaContainer, videoUrl, width, height) {
    var embedWidth = Math.max(200, Math.round(width || 360));
    var embedHeight = Math.max(200, Math.round(height || embedWidth));
    var sizedUrl = resizeNivodaEmbedUrl(videoUrl, embedWidth, embedHeight);
    var currentIframe = mediaContainer.querySelector("iframe.diamond-detail-view__media-embed");
    var currentWidth = mediaContainer.getAttribute("data-embed-width");
    var currentHeight = mediaContainer.getAttribute("data-embed-height");

    if (
      currentIframe &&
      currentWidth === String(embedWidth) &&
      currentHeight === String(embedHeight) &&
      currentIframe.src === sizedUrl
    ) {
      return;
    }

    mediaContainer.innerHTML = "";
    mediaContainer.setAttribute("data-embed-width", String(embedWidth));
    mediaContainer.setAttribute("data-embed-height", String(embedHeight));

    var iframe = document.createElement("iframe");
    iframe.src = sizedUrl;
    iframe.title = "Diamond 360 video";
    iframe.className = "diamond-detail-view__media-embed";
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute(
      "allow",
      "autoplay; fullscreen; gyroscope; accelerometer"
    );
    mediaContainer.appendChild(iframe);
  }

  function hasSelectedSetting() {
    try {
      var raw = localStorage.getItem("ringBuilderSelectedSetting");
      if (!raw) return false;
      var setting = JSON.parse(raw);
      return !!(setting && setting.productHandle);
    } catch (e) {
      return false;
    }
  }

  function getSelectedSettingShape() {
    try {
      var raw = localStorage.getItem("ringBuilderSelectedSetting");
      if (!raw) return "";
      var setting = JSON.parse(raw);
      return setting && setting.diamondShape ? String(setting.diamondShape).trim() : "";
    } catch (e) {
      return "";
    }
  }

  function shapeLabelToApi(label) {
    if (
      window.RingBuilderShapeUtils &&
      typeof window.RingBuilderShapeUtils.normalizeShapeLabelToApi === "function"
    ) {
      return window.RingBuilderShapeUtils.normalizeShapeLabelToApi(label);
    }
    if (!label) return "";
    return normalizeShapeKey(label);
  }

  function applySettingShapeFromSelection(force) {
    if (isStandaloneDiamondBrowse()) return false;
    if (isDiamondFirst()) return false;
    if (!hasSelectedSetting()) return false;
    if (!force) {
      var urlFilters = parseUrlToFilters();
      if (urlFilters && urlFilters.shape) return false;
    }
    var shapeApi = shapeLabelToApi(getSelectedSettingShape());
    if (!shapeApi) return false;
    applyShapeFilter(shapeApi);
    syncFiltersToUrl(getFilters());
    return true;
  }

  function applySettingShapeDefaultIfNeeded() {
    return applySettingShapeFromSelection(false);
  }

  function getFlow() {
    if (
      window.RingBuilderFlow &&
      typeof window.RingBuilderFlow.getFlow === "function"
    ) {
      return window.RingBuilderFlow.getFlow();
    }
    return localStorage.getItem(FLOW_KEY) === FLOW_DIAMOND_FIRST
      ? FLOW_DIAMOND_FIRST
      : "setting-first";
  }

  function isDiamondFirst() {
    return getFlow() === FLOW_DIAMOND_FIRST;
  }

  function getNextStepAfterDiamondSelection() {
    return hasSelectedSetting() ? "3" : "2";
  }

  function buildRingBuilderUrl(step) {
    if (
      window.RingBuilderFlow &&
      typeof window.RingBuilderFlow.buildRingBuilderUrl === "function"
    ) {
      return window.RingBuilderFlow.buildRingBuilderUrl(getFlow(), step);
    }

    // Query-param URLs only — /diamonds|/settings path segments 301 on Shopify.
    var redirectUrl = "/collections/ring-builder";
    var params = new URLSearchParams();
    params.set(
      "flow",
      getFlow() === FLOW_DIAMOND_FIRST ? FLOW_DIAMOND_FIRST : "setting-first",
    );
    if (step && String(step) !== "1") {
      params.set("step", String(step));
    }
    if (window.location.search.indexOf("_fd=0") !== -1) {
      params.set("_fd", "0");
    }
    var qs = params.toString();
    return qs ? redirectUrl + "?" + qs : redirectUrl;
  }

  function getRetailDollars(item) {
    return getRetailCents(item && item.price) / 100;
  }

  function getRequestedPriceBounds(filters) {
    var defaults = getFilterDefaults();
    if (
      !filters ||
      isFullRange(filters.price_min, filters.price_max, defaults.priceMin, defaults.priceMax)
    ) {
      return null;
    }
    return {
      min: parseFilterNumber(filters.price_min, defaults.priceMin),
      max: parseFilterNumber(filters.price_max, defaults.priceMax),
    };
  }

  function itemWithinPriceBounds(item, bounds) {
    if (!bounds) return true;
    var dollars = getRetailDollars(item);
    if (!isFinite(dollars) || dollars <= 0) return false;
    return dollars + 0.001 >= bounds.min && dollars - 0.001 <= bounds.max;
  }

  function getRetailCents(price) {
    var dollars;
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.applyMarginToNivodaCents === "function"
    ) {
      dollars = window.RingBuilderDiamondMargin.applyMarginToNivodaCents(price);
    } else {
      dollars = Number(price) / 100;
    }
    if (!isFinite(dollars) || dollars <= 0) return 0;
    return Math.round(dollars * 100);
  }

  function formatMoneyCents(cents) {
    var amount = Math.max(0, Math.round(Number(cents) || 0));
    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === "function"
    ) {
      return window.theme.Currency.formatMoney(
        amount,
        window.theme.moneyFormat || "${{amount}}",
      );
    }
    return "$" + (amount / 100).toFixed(2);
  }

  function updateDiamondPaymentOffers(detailView, item) {
    var wrap = detailView && detailView.querySelector("[data-detail-payments]");
    if (!wrap) return;

    var retailCents = getRetailCents(item && item.price);
    if (retailCents <= 0) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var installmentText = formatMoneyCents(Math.floor(retailCents / 4));
    var afterpayEl = wrap.querySelector("[data-detail-afterpay-amount]");
    if (afterpayEl) afterpayEl.textContent = installmentText;

    var paypalAmountEl = wrap.querySelector("[data-detail-paypal-amount]");
    if (paypalAmountEl) paypalAmountEl.textContent = installmentText;
  }

  function formatPrice(price) {
    if (window.RingBuilderDiamondMargin) {
      return window.RingBuilderDiamondMargin.formatRetailMoney(price);
    }

    var amount = Number(price);
    if (!isFinite(amount)) return "";

    var dollars = Math.round(amount / 100);
    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === "function"
    ) {
      var format = String(window.theme.moneyFormat || "${{amount}}").replace(
        /\{\{\s*amount\s*\}\}/g,
        "{{amount_no_decimals}}",
      );
      return window.theme.Currency.formatMoney(dollars * 100, format);
    }

    return "$" + dollars.toLocaleString();
  }

  function formatCompareAtPrice(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.formatCompareAtMoney === "function"
    ) {
      return window.RingBuilderDiamondMargin.formatCompareAtMoney(price);
    }
    return "";
  }

  function getSellingBadgeText(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.getSellingBadge === "function"
    ) {
      return window.RingBuilderDiamondMargin.getSellingBadge(null, price);
    }
    return "";
  }

  function formatCarats(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "";
    return value.toFixed(2) + "ct";
  }

  var shapeIconUrlCache = null;

  function getShapeIconUrls() {
    if (shapeIconUrlCache) return shapeIconUrlCache;
    var el = document.getElementById("ring-builder-shape-icons");
    if (!el) {
      shapeIconUrlCache = {};
      return shapeIconUrlCache;
    }
    try {
      shapeIconUrlCache = JSON.parse(el.textContent);
    } catch (e) {
      shapeIconUrlCache = {};
    }
    return shapeIconUrlCache;
  }

  function normalizeShapeKey(shape) {
    return String(shape || "ROUND")
      .toUpperCase()
      .replace(/[\s-]+/g, "_");
  }

  function getShapeIconUrl(shape) {
    var urls = getShapeIconUrls();
    var key = normalizeShapeKey(shape);
    var aliases = {
      SQ_EMERALD: 'EMERALD',
      SQ_RADIANT: 'RADIANT',
      CUSHION_ALL: 'CUSHION',
      CUSHION_BRILLIANT: 'CUSHION',
      CUSHION_MODIFIED: 'CUSHION',
      SQUARE_CUSHION: 'CUSHION',
      HALF_MOON: 'MARQUISE',
      OLD_MINER: 'ROUND',
      EUROPEAN_CUT: 'ROUND',
      SQUARE: 'PRINCESS',
      BAGUETTE: 'EMERALD',
      TAPERED_BAGUETTE: 'EMERALD',
      BULLET: 'PEAR',
      TAPERED_BULLET: 'PEAR',
      STAR: 'ROUND',
      ROSE: 'ROUND',
    };
    if (aliases[key] && urls[aliases[key]]) return urls[aliases[key]];
    if (urls[key]) return urls[key];
    if (key.indexOf('CUSHION') === 0 && urls.CUSHION) return urls.CUSHION;
    var base = key.split('_')[0];
    return urls[base] || urls.ROUND || '';
  }

  function formatTableCarats(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "—";
    var text =
      Math.abs(value - Math.round(value)) < 0.001
        ? String(Math.round(value))
        : String(parseFloat(value.toFixed(2)));
    return text + " Ct";
  }

  function formatTablePrice(price) {
    if (window.RingBuilderDiamondMargin) {
      return window.RingBuilderDiamondMargin.formatRetailMoneyRounded(price);
    }

    var amount = Number(price);
    if (!isFinite(amount)) return "—";
    var dollars = amount / 100;
    return "$" + Math.round(dollars).toLocaleString();
  }

  function formatTableLab(lab) {
    if (!lab) return "—";
    return String(lab).trim().toUpperCase();
  }

  function formatCaratsTitle(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "";
    return value.toFixed(2) + "ct";
  }

  function formatDimensions(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    var depth = Number(item.depth);
    if (!isFinite(length) || !isFinite(width) || !isFinite(depth)) return "";
    return (
      length.toFixed(2) +
      " x " +
      width.toFixed(2) +
      " x " +
      depth.toFixed(2)
    );
  }

  function getSkuLabel(item) {
    return item.diamondId || item.certNumber || item.offerId || "";
  }

  function isLabDiamond(item) {
    return item.labgrown === true || item.labgrown === "true";
  }

  function getDiamondOriginBadgeLabel(item) {
    return isLabDiamond(item) ? "Lab Diamonds" : "Natural Diamond";
  }

  function populateDetailOriginBadge(detailView, item) {
    if (!detailView) return;
    var badgeEl = detailView.querySelector("[data-detail-origin-badge]");
    if (!badgeEl) return;
    badgeEl.textContent = getDiamondOriginBadgeLabel(item);
    badgeEl.hidden = false;
  }

  function formatCertSummary(item) {
    var parts = [];
    if (item.color) parts.push(item.color);
    if (item.clarity) parts.push(item.clarity);
    if (item.lab) parts.push(item.lab + " Certified");
    return parts.join(" · ");
  }

  function formatDiamondCardTitle(item) {
    var carats = Number(item.carats);
    var caratLabel = isFinite(carats)
      ? (carats % 1 === 0 ? String(carats) : carats.toFixed(2).replace(/\.?0+$/, ""))
      : "";
    var shape = formatShapeLabel(item.shape);
    var suffix = isLabDiamond(item) ? " Lab Grown Diamond" : " Diamond";
    return (caratLabel ? caratLabel + " Carat " : "") + shape + suffix;
  }

  function setFieldText(card, field, text) {
    var el = card.querySelector('[data-diamond-field="' + field + '"]');
    if (el) el.textContent = text || "";
  }

  function setFieldVisibility(card, field, visible) {
    var el = card.querySelector('[data-diamond-field="' + field + '"]');
    if (el) el.hidden = !visible;
  }

  function getCardMediaUrl(item) {
    var image = item.image && String(item.image).trim();
    if (image) return { url: image, fallback: false, sample: false };

    var sampleUrl = getSampleDiamondImageUrl(item && item.shape);
    if (sampleUrl) return { url: sampleUrl, fallback: false, sample: true };

    return { url: getDiamondPlaceholderUrl(), fallback: true, sample: false };
  }

  function setCardSampleBadge(card, visible) {
    setFieldVisibility(card, "sample-badge", !!visible);
  }

  function resetCardImagePlaceholder(card) {
    var placeholder = card.querySelector('[data-diamond-field="image-placeholder"]');
    if (!placeholder) return;
    var icon = placeholder.querySelector(".ub-diamond-card__placeholder-icon");
    if (icon && !icon.getAttribute("src")) {
      icon.setAttribute("src", getDiamondPlaceholderUrl());
    }
  }

  function showCardImagePlaceholder(card) {
    var imageEl = card.querySelector('[data-diamond-field="image"]');
    if (imageEl) {
      imageEl.hidden = true;
      imageEl.removeAttribute("src");
      imageEl.onload = null;
      imageEl.onerror = null;
      imageEl.classList.remove("ub-diamond-card__image--placeholder");
      imageEl.classList.remove("ub-diamond-card__image--sample");
    }

    resetCardImagePlaceholder(card);
    setCardSampleBadge(card, false);
    setFieldVisibility(card, "image-placeholder", true);
  }

  function applyCardImage(card, item, title) {
    var imageEl = card.querySelector('[data-diamond-field="image"]');
    if (!imageEl) return;

    var media = getCardMediaUrl(item);

    imageEl.onload = null;
    imageEl.onerror = null;
    imageEl.classList.remove("ub-diamond-card__image--placeholder");
    imageEl.classList.remove("ub-diamond-card__image--sample");
    resetCardImagePlaceholder(card);

    function revealImage(url, isFallback, isSample) {
      imageEl.src = url;
      imageEl.alt = title;
      imageEl.hidden = false;
      imageEl.classList.toggle("ub-diamond-card__image--placeholder", !!isFallback);
      imageEl.classList.toggle("ub-diamond-card__image--sample", !!isSample);
      setFieldVisibility(card, "image-placeholder", false);
      setCardSampleBadge(card, !!isSample);

      imageEl.onerror = function onImageError() {
        imageEl.onerror = null;
        var failedUrl = imageEl.src;

        if (!isFallback && !isSample) {
          var sampleUrl = getSampleDiamondImageUrl(item && item.shape);
          if (sampleUrl && failedUrl !== sampleUrl) {
            revealImage(sampleUrl, false, true);
            return;
          }
        }

        var placeholderUrl = getDiamondPlaceholderUrl();
        if (!isFallback && placeholderUrl && failedUrl !== placeholderUrl) {
          revealImage(placeholderUrl, true, false);
          return;
        }
        imageEl.hidden = true;
        imageEl.removeAttribute("src");
        showCardImagePlaceholder(card);
      };
    }

    if (media.url) {
      revealImage(media.url, media.fallback, media.sample);
    } else {
      showCardImagePlaceholder(card);
    }
  }

  function populateUbCard(card, item) {
    var payload = JSON.stringify(item);
    var shapeLabel = formatShapeLabel(item.shape);
    var title = formatDiamondCardTitle(item);
    var dimensions = formatDimensions(item);
    var media = getCardMediaUrl(item);

    card.setAttribute("data-offer-id", item.offerId || "");

    setFieldVisibility(card, "lab-badge", isLabDiamond(item));
    setFieldVisibility(card, "growth-method", false);

    applyCardImage(card, item, title);

    var hasVideo = !!item.video;
    setFieldVisibility(card, "dots", !!media.url || hasVideo);
    var videoDot = card.querySelector('[data-diamond-dot="video"]');
    if (videoDot) videoDot.hidden = !hasVideo;

    setFieldText(card, "lab-label", item.lab || "IGI");
    setFieldText(card, "title", title);
    setFieldText(card, "cert", formatCertSummary(item));
    setFieldText(card, "dimensions", dimensions);
    setFieldVisibility(card, "dimensions", !!dimensions);
    setFieldText(card, "sku", getSkuLabel(item));
    setFieldText(card, "price", formatPrice(item.price));

    var compareAtText = formatCompareAtPrice(item.price);
    setFieldText(card, "compare-at", compareAtText);
    setFieldVisibility(card, "compare-at", !!compareAtText);

    var badgeText = getSellingBadgeText(item.price);
    setFieldText(card, "selling-badge", badgeText);
    setFieldVisibility(card, "selling-badge", !!badgeText);

    var selectBtn = card.querySelector("[data-diamond-select]");
    if (selectBtn) {
      selectBtn.setAttribute("data-diamond-payload", payload);
    }
  }

  function createUbCardNode(item) {
    var template = document.getElementById("diamond-card-ub-template");
    if (!template || !template.content) return null;

    var config = getConfig();
    var node = template.content.firstElementChild.cloneNode(true);
    if (config.gridClass) {
      config.gridClass.split(/\s+/).forEach(function (cls) {
        if (cls) node.classList.add(cls);
      });
    }

    populateUbCard(node, item);
    return node;
  }

  function formatShapeLabel(shape) {
    if (!shape) return "Diamond";
    return String(shape)
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  function shapeIconSvg(shape) {
    var key = String(shape || "ROUND").toUpperCase();
    var icons = {
      ROUND:
        '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="50" cy="50" r="46" />' +
        '<polygon points="50,30 64.1,35.9 70,50 64.1,64.1 50,70 35.9,64.1 30,50 35.9,35.9" />' +
        '<polygon points="50,4 50,30 35.9,35.9" />' +
        '<polygon points="50,4 50,30 64.1,35.9" />' +
        '<polygon points="96,50 70,50 64.1,35.9" />' +
        '<polygon points="96,50 70,50 64.1,64.1" />' +
        '<polygon points="50,96 50,70 64.1,64.1" />' +
        '<polygon points="50,96 50,70 35.9,64.1" />' +
        '<polygon points="4,50 30,50 35.9,64.1" />' +
        '<polygon points="4,50 30,50 35.9,35.9" />' +
        '<polygon points="18,18 35.9,35.9 30,50" />' +
        '<polygon points="18,18 35.9,35.9 50,30" />' +
        '<polygon points="82,18 64.1,35.9 50,30" />' +
        '<polygon points="82,18 64.1,35.9 70,50" />' +
        '<polygon points="82,82 64.1,64.1 70,50" />' +
        '<polygon points="82,82 64.1,64.1 50,70" />' +
        '<polygon points="18,82 35.9,64.1 50,70" />' +
        '<polygon points="18,82 35.9,64.1 30,50" />' +
        '<line x1="50" y1="4" x2="18" y2="18" />' +
        '<line x1="96" y1="50" x2="82" y2="18" />' +
        '<line x1="96" y1="50" x2="82" y2="82" />' +
        '<line x1="50" y1="96" x2="82" y2="82" />' +
        '<line x1="50" y1="96" x2="18" y2="82" />' +
        '<line x1="4" y1="50" x2="18" y2="82" />' +
        '<line x1="4" y1="50" x2="18" y2="18" />' +
        '<line x1="50" y1="4" x2="82" y2="18" />' +
        '</svg>',
      OVAL:
        '<svg viewBox="0 0 100 130" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M50,5 C80,5 95,35 95,65 C95,95 80,125 50,125 C20,125 5,95 5,65 C5,35 20,5 50,5 Z" />' +
        '<path d="M50,35 C65,35 75,48 75,65 C75,82 65,95 50,95 C35,95 25,82 25,65 C25,48 35,35 50,35 Z" />' +
        '<line x1="50" y1="5" x2="50" y2="35" />' +
        '<line x1="50" y1="125" x2="50" y2="95" />' +
        '<line x1="5" y1="65" x2="25" y2="65" />' +
        '<line x1="95" y1="65" x2="75" y2="65" />' +
        '<line x1="18.2" y1="22.6" x2="32.3" y2="43.8" />' +
        '<line x1="81.8" y1="22.6" x2="67.7" y2="43.8" />' +
        '<line x1="81.8" y1="107.4" x2="67.7" y2="86.2" />' +
        '<line x1="18.2" y1="107.4" x2="32.3" y2="86.2" />' +
        '<polygon points="50,5 32.3,43.8 50,35" />' +
        '<polygon points="50,5 67.7,43.8 50,35" />' +
        '<polygon points="95,65 67.7,43.8 75,65" />' +
        '<polygon points="95,65 67.7,86.2 75,65" />' +
        '<polygon points="50,125 67.7,86.2 50,95" />' +
        '<polygon points="50,125 32.3,86.2 50,95" />' +
        '<polygon points="5,65 32.3,86.2 25,65" />' +
        '<polygon points="5,65 32.3,43.8 25,65" />' +
        '</svg>',
      CUSHION:
        '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="5" y="5" width="90" height="90" rx="25" />' +
        '<polygon points="50,25 68,32 75,50 68,68 50,75 32,68 25,50 32,32" />' +
        '<line x1="50" y1="5" x2="50" y2="25" />' +
        '<line x1="50" y1="95" x2="50" y2="75" />' +
        '<line x1="5" y1="50" x2="25" y2="50" />' +
        '<line x1="95" y1="50" x2="75" y2="50" />' +
        '<line x1="15" y1="15" x2="32" y2="32" />' +
        '<line x1="85" y1="15" x2="68" y2="32" />' +
        '<line x1="85" y1="85" x2="68" y2="68" />' +
        '<line x1="15" y1="85" x2="32" y2="68" />' +
        '<polygon points="50,5 32,32 50,25" />' +
        '<polygon points="50,5 68,32 50,25" />' +
        '<polygon points="95,50 68,32 75,50" />' +
        '<polygon points="95,50 68,68 75,50" />' +
        '<polygon points="50,95 68,68 50,75" />' +
        '<polygon points="50,95 32,68 50,75" />' +
        '<polygon points="5,50 32,68 25,50" />' +
        '<polygon points="5,50 32,32 25,50" />' +
        '<polygon points="15,15 32,32 25,50" />' +
        '<polygon points="15,15 32,32 50,25" />' +
        '<polygon points="85,15 68,32 50,25" />' +
        '<polygon points="85,15 68,32 75,50" />' +
        '<polygon points="85,85 68,68 75,50" />' +
        '<polygon points="85,85 68,68 50,75" />' +
        '<polygon points="15,85 32,68 50,75" />' +
        '<polygon points="15,85 32,68 25,50" />' +
        '</svg>',
      EMERALD:
        '<svg viewBox="0 0 100 120" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<polygon points="20,5 80,5 95,20 95,100 80,115 20,115 5,100 5,20" />' +
        '<polygon points="23,12 77,12 88,23 88,97 77,108 23,108 12,97 12,23" />' +
        '<polygon points="27,20 73,20 80,27 80,93 73,100 27,100 20,93 20,27" />' +
        '<polygon points="32,30 68,30 73,35 73,85 68,90 32,90 27,85 27,35" />' +
        '<line x1="5" y1="20" x2="27" y2="35" />' +
        '<line x1="95" y1="20" x2="73" y2="35" />' +
        '<line x1="95" y1="100" x2="73" y2="85" />' +
        '<line x1="5" y1="100" x2="27" y2="85" />' +
        '<line x1="20" y1="5" x2="32" y2="30" />' +
        '<line x1="80" y1="5" x2="68" y2="30" />' +
        '<line x1="80" y1="115" x2="68" y2="90" />' +
        '<line x1="20" y1="115" x2="32" y2="90" />' +
        '</svg>',
      PRINCESS:
        '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="5" y="5" width="90" height="90" />' +
        '<polygon points="50,25 75,50 50,75 25,50" />' +
        '<rect x="35" y="35" width="30" height="30" />' +
        '<line x1="5" y1="5" x2="35" y2="35" />' +
        '<line x1="95" y1="5" x2="65" y2="35" />' +
        '<line x1="95" y1="95" x2="65" y2="65" />' +
        '<line x1="5" y1="95" x2="35" y2="65" />' +
        '<line x1="50" y1="5" x2="50" y2="25" />' +
        '<line x1="50" y1="95" x2="50" y2="75" />' +
        '<line x1="5" y1="50" x2="25" y2="50" />' +
        '<line x1="95" y1="50" x2="75" y2="50" />' +
        '<line x1="50" y1="25" x2="50" y2="35" />' +
        '<line x1="50" y1="75" x2="50" y2="65" />' +
        '<line x1="25" y1="50" x2="35" y2="50" />' +
        '<line x1="75" y1="50" x2="65" y2="50" />' +
        '<polygon points="5,5 50,5 35,35" />' +
        '<polygon points="95,5 50,5 65,35" />' +
        '<polygon points="95,5 95,50 65,35" />' +
        '<polygon points="95,95 95,50 65,65" />' +
        '<polygon points="95,95 50,95 65,65" />' +
        '<polygon points="5,95 50,95 35,65" />' +
        '<polygon points="5,95 5,50 35,65" />' +
        '<polygon points="5,5 5,50 35,35" />' +
        '</svg>',
      RADIANT:
        '<svg viewBox="0 0 100 120" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<polygon points="20,5 80,5 95,20 95,100 80,115 20,115 5,100 5,20" />' +
        '<polygon points="35,35 65,35 72,42 72,78 65,85 35,85 28,78 28,42" />' +
        '<line x1="5" y1="20" x2="28" y2="42" />' +
        '<line x1="95" y1="20" x2="72" y2="42" />' +
        '<line x1="95" y1="100" x2="72" y2="78" />' +
        '<line x1="5" y1="100" x2="28" y2="78" />' +
        '<line x1="20" y1="5" x2="35" y2="35" />' +
        '<line x1="80" y1="5" x2="65" y2="35" />' +
        '<line x1="80" y1="115" x2="65" y2="85" />' +
        '<line x1="20" y1="115" x2="35" y2="85" />' +
        '<line x1="50" y1="5" x2="50" y2="35" />' +
        '<line x1="50" y1="115" x2="50" y2="85" />' +
        '<line x1="5" y1="60" x2="28" y2="60" />' +
        '<line x1="95" y1="60" x2="72" y2="60" />' +
        '<polygon points="20,5 50,5 35,35" />' +
        '<polygon points="80,5 50,5 65,35" />' +
        '<polygon points="95,20 95,60 72,42" />' +
        '<polygon points="95,100 95,60 72,78" />' +
        '<polygon points="80,115 50,115 65,85" />' +
        '<polygon points="20,115 50,115 35,85" />' +
        '<polygon points="5,100 5,60 28,78" />' +
        '<polygon points="5,20 5,60 28,42" />' +
        '</svg>',
      PEAR:
        '<svg viewBox="0 0 100 130" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M50,5 C50,5 95,65 95,95 A45,45 0 0,1 5,95 C5,65 50,5 50,5 Z" />' +
        '<path d="M50,35 C50,35 75,70 75,90 A25,25 0 0,1 25,90 C25,70 50,35 50,35 Z" />' +
        '<line x1="50" y1="5" x2="50" y2="35" />' +
        '<line x1="50" y1="90" x2="50" y2="125" />' +
        '<line x1="5" y1="95" x2="25" y2="90" />' +
        '<line x1="95" y1="95" x2="75" y2="90" />' +
        '<line x1="18.2" y1="65" x2="35" y2="68" />' +
        '<line x1="81.8" y1="65" x2="65" y2="68" />' +
        '<polygon points="50,5 35,68 50,35" />' +
        '<polygon points="50,5 65,68 50,35" />' +
        '<polygon points="95,95 65,68 75,90" />' +
        '<polygon points="5,95 35,68 25,90" />' +
        '<line x1="18" y1="118" x2="32" y2="105" />' +
        '<line x1="82" y1="118" x2="68" y2="105" />' +
        '<line x1="50" y1="90" x2="32" y2="105" />' +
        '<line x1="50" y1="90" x2="68" y2="105" />' +
        '</svg>',
      MARQUISE:
        '<svg viewBox="0 0 100 140" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M50,5 C75,45 95,70 95,70 C95,70 75,95 50,135 C25,95 5,70 5,70 C5,70 25,45 50,5 Z" />' +
        '<path d="M50,35 C65,55 75,70 75,70 C75,70 65,85 50,105 C35,85 25,70 25,70 C25,70 35,55 50,35 Z" />' +
        '<line x1="50" y1="5" x2="50" y2="35" />' +
        '<line x1="50" y1="105" x2="50" y2="135" />' +
        '<line x1="5" y1="70" x2="25" y2="70" />' +
        '<line x1="95" y1="70" x2="75" y2="70" />' +
        '<polygon points="50,5 25,70 50,35" />' +
        '<polygon points="50,5 75,70 50,35" />' +
        '<polygon points="50,135 25,70 50,105" />' +
        '<polygon points="50,135 75,70 50,105" />' +
        '<line x1="18" y1="38" x2="35" y2="53" />' +
        '<line x1="82" y1="38" x2="65" y2="53" />' +
        '<line x1="18" y1="102" x2="35" y2="87" />' +
        '<line x1="82" y1="102" x2="65" y2="87" />' +
        '</svg>',
      ASSCHER:
        '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<polygon points="25,5 75,5 95,25 95,75 75,95 25,95 5,75 5,25" />' +
        '<polygon points="28,12 72,12 88,28 88,72 72,88 28,88 12,72 12,28" />' +
        '<polygon points="32,20 68,20 80,32 80,68 68,80 32,80 20,68 20,32" />' +
        '<polygon points="38,28 62,28 72,38 72,62 62,72 38,72 28,62 28,38" />' +
        '<line x1="5" y1="25" x2="38" y2="38" />' +
        '<line x1="95" y1="25" x2="62" y2="38" />' +
        '<line x1="95" y1="75" x2="62" y2="62" />' +
        '<line x1="5" y1="75" x2="38" y2="62" />' +
        '<line x1="25" y1="5" x2="38" y2="28" />' +
        '<line x1="75" y1="5" x2="62" y2="28" />' +
        '<line x1="75" y1="95" x2="62" y2="72" />' +
        '<line x1="25" y1="95" x2="38" y2="72" />' +
        '</svg>',
      HEART:
        '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M50,18 C50,18 40,5 20,5 A18,18 0 0,0 2,23 C2,45 35,70 50,95 C65,70 98,45 98,23 A18,18 0 0,0 80,5 C60,5 50,18 50,18 Z" />' +
        '<path d="M50,38 C50,38 43,28 30,28 A10,10 0 0,0 20,38 C20,50 40,65 50,80 C60,65 80,50 80,38 A10,10 0 0,0 70,28 C57,28 50,38 50,38 Z" />' +
        '<line x1="50" y1="18" x2="50" y2="38" />' +
        '<line x1="50" y1="80" x2="50" y2="95" />' +
        '<line x1="2" y1="23" x2="20" y2="38" />' +
        '<line x1="98" y1="23" x2="80" y2="38" />' +
        '<polygon points="50,18 20,38 50,38" />' +
        '<polygon points="50,18 80,38 50,38" />' +
        '<polygon points="50,95 20,38 50,80" />' +
        '<polygon points="50,95 80,38 50,80" />' +
        '<line x1="20" y1="5" x2="30" y2="28" />' +
        '<line x1="80" y1="5" x2="70" y2="28" />' +
        '<line x1="10" y1="55" x2="30" y2="55" />' +
        '<line x1="90" y1="55" x2="70" y2="55" />' +
        '</svg>',
    };
    return icons[key] || icons.ROUND;
  }

  function syncCheckboxHiddenInput(group) {
    if (!group) return;
    var hidden = group.querySelector("[data-diamond-filter]");
    if (!hidden) return;
    var active = [];
    group.querySelectorAll(".rb-filter-checkbox__input:checked").forEach(function (checkbox) {
      if (checkbox.value) active.push(checkbox.value);
    });
    hidden.value = active.join(",");
  }

  function syncPillHiddenInput(group) {
    if (!group) return;
    var hidden = group.querySelector("[data-diamond-filter]");
    if (!hidden) return;
    var active = [];
    group.querySelectorAll(".rb-filter-pill.is-active").forEach(function (pill) {
      var value = pill.getAttribute("data-pill-value");
      if (value) active.push(value);
    });
    hidden.value = active.join(",");
  }

  var DIAMOND_FILTER_URL_KEYS = [
    "Shape",
    "PriceFrom",
    "PriceTo",
    "CaratFrom",
    "CaratTo",
    "Color",
    "Cut",
    "Clarity",
    "Polish",
    "Symmetry",
    "Fluorescence",
    "Report",
    "DepthFrom",
    "DepthTo",
    "TableFrom",
    "TableTo",
    "RatioFrom",
    "RatioTo",
    "CertNumber",
    "DiamondType",
    "ColourMode",
    "FancyColor",
    "FancyIntensity",
    "FancyOvertone",
    "Sort",
  ];

  var RESERVED_QUERY_KEYS = ["step", "flow", "_fd", "ring-builder"];

  var FALLBACK_DIAMOND_SORT = "price_asc";

  var DIAMOND_SORT_LABELS = {
    price_desc: "Price: High to Low",
    price_asc: "Price: Low to High",
    price_per_carat_desc: "Price per carat: High to Low",
    price_per_carat_asc: "Price per carat: Low to High",
    carats_desc: "Carat: High to Low",
    carats_asc: "Carat: Low to High",
  };

  var FILTER_DEFAULTS = {
    price_min: 0,
    price_max: 150000,
    carat_min: 0.01,
    carat_max: 10,
    depth_min: 30,
    depth_max: 90,
    table_min: 30,
    table_max: 90,
    ratio_min: 0.8,
    ratio_max: 2.5,
  };

  function parseFilterNumber(value, fallback) {
    var num = parseFloat(value);
    return isFinite(num) ? num : fallback;
  }

  function isFullRange(minVal, maxVal, defMin, defMax) {
    var min = parseFilterNumber(minVal, defMin);
    var max = parseFilterNumber(maxVal, defMax);
    return min <= defMin && max >= defMax;
  }

  window.RING_BUILDER_DIAMOND_FILTER_URL_KEYS = DIAMOND_FILTER_URL_KEYS;

  function getDefaultDiamondSort() {
    var root = getRoot();
    var fromDom = root && root.getAttribute("data-default-sort");
    var key = String(fromDom || FALLBACK_DIAMOND_SORT)
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
    return DIAMOND_SORT_LABELS[key] ? key : FALLBACK_DIAMOND_SORT;
  }

  function normalizeDiamondSort(value) {
    var key = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
    return DIAMOND_SORT_LABELS[key] ? key : getDefaultDiamondSort();
  }

  function getDiamondSortLabel(value) {
    return DIAMOND_SORT_LABELS[normalizeDiamondSort(value)] || DIAMOND_SORT_LABELS[getDefaultDiamondSort()];
  }

  function setSortMenuOpen(isOpen) {
    var root = getRoot();
    if (!root) return;
    var sortRoot = root.querySelector("[data-diamond-sort]");
    var trigger = root.querySelector("[data-diamond-sort-trigger]");
    var menu = root.querySelector("[data-diamond-sort-menu]");
    if (!sortRoot || !trigger || !menu) return;

    sortRoot.classList.toggle("is-open", !!isOpen);
    trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    menu.hidden = !isOpen;
  }

  function applySortFilter(sortValue) {
    var root = getRoot();
    if (!root) return;
    var normalized = normalizeDiamondSort(sortValue);
    var sortInput = root.querySelector('[data-diamond-filter="sort"]');
    var labelEl = root.querySelector("[data-diamond-sort-label]");

    if (sortInput) sortInput.value = normalized;
    if (labelEl) labelEl.textContent = getDiamondSortLabel(normalized);

    root.querySelectorAll("[data-diamond-sort-option]").forEach(function (btn) {
      var active = normalizeDiamondSort(btn.getAttribute("data-sort")) === normalized;
      btn.classList.toggle("is-selected", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  /** One swatch can map to multiple Nivoda shapes: CUSHION+CUSHION BRILLIANT */
  function shapeApiValues(shapeApi) {
    if (!shapeApi) return [];
    return String(shapeApi)
      .toUpperCase()
      .replace(/\+/g, ",")
      .split(",")
      .map(function (part) {
        // Nivoda expects spaces ("CUSHION BRILLIANT"), not underscores.
        return part
          .trim()
          .replace(/_/g, " ")
          .replace(/\s+/g, " ");
      })
      .filter(Boolean);
  }

  function normalizeShapeApiValue(shapeApi) {
    return shapeApiValues(shapeApi).join(",");
  }

  function shapesMatch(a, b) {
    var av = shapeApiValues(a);
    var bv = shapeApiValues(b);
    if (!av.length || !bv.length) return false;
    if (av.join(",") === bv.join(",")) return true;
    if (av.length === 1) return bv.indexOf(av[0]) !== -1;
    if (bv.length === 1) return av.indexOf(bv[0]) !== -1;
    return av.some(function (value) {
      return bv.indexOf(value) !== -1;
    });
  }

  function findShapeSwatchButton(shapeApi) {
    var root = getRoot();
    if (!root || !shapeApi) return null;
    var buttons = root.querySelectorAll("[data-diamond-shape-swatch]");
    for (var i = 0; i < buttons.length; i++) {
      if (shapesMatch(buttons[i].getAttribute("data-shape"), shapeApi)) {
        return buttons[i];
      }
    }
    return null;
  }

  function getShapeDisplayLabel(shapeApi) {
    var btn = findShapeSwatchButton(shapeApi);
    if (btn) {
      var labelEl = btn.querySelector(".diamond-shape-swatch__label");
      if (labelEl && labelEl.textContent) return labelEl.textContent.trim();
      var title = btn.getAttribute("title");
      if (title) return title.trim();
    }
    var first = shapeApiValues(shapeApi)[0];
    return first ? formatShapeLabel(first) : "";
  }

  function shapeToUrlValue(apiShape) {
    // Prefer the full multi-value mapping from the active swatch (for URL + reload).
    var btn = findShapeSwatchButton(apiShape);
    var values = shapeApiValues(
      btn ? btn.getAttribute("data-shape") : apiShape,
    );
    if (!values.length) {
      return getShapeDisplayLabel(apiShape) || "";
    }
    // Comma-separated Nivoda values with spaces, e.g. CUSHION,CUSHION BRILLIANT,CUSHION MODIFIED
    return values.join(",");
  }

  function shapeFromUrlValue(urlShape) {
    if (!urlShape) return "";
    // Support display label ("Cushion"), single API value, or multi CSV / + list.
    var raw = String(urlShape).trim();
    var btn = findShapeSwatchButton(raw);
    if (btn) return (btn.getAttribute("data-shape") || "").toUpperCase();

    var asKey = raw.toUpperCase().replace(/[\s-]+/g, "_");
    btn = findShapeSwatchButton(asKey);
    if (btn) return (btn.getAttribute("data-shape") || "").toUpperCase();

    return normalizeShapeApiValue(raw);
  }

  function getUrlParam(params) {
    var keys = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < keys.length; i++) {
      var val = params.get(keys[i]);
      if (val) return val;
    }
    return "";
  }

  function hasDiamondFilterParams(params) {
    if (params.has("diamondId")) return true;
    return DIAMOND_FILTER_URL_KEYS.some(function (key) {
      return params.has(key);
    });
  }

  function parseUrlToFilters() {
    var params = new URLSearchParams(window.location.search);
    if (!hasDiamondFilterParams(params)) return null;

    var diamondTypeRaw = getUrlParam(params, "DiamondType");
    // Lab grown is the UI default. Legacy filter URLs with no DiamondType were
    // natural. A share link with only diamondId should keep the lab-grown default.
    var diamondType = diamondTypeRaw ? "labgrown" : "natural";
    if (!diamondTypeRaw && params.has("diamondId")) {
      diamondType = getDefaultDiamondType();
    }
    if (diamondTypeRaw && /colou?red|fancy/i.test(diamondTypeRaw)) {
      diamondType = "labgrown_colour";
    } else if (diamondTypeRaw && /lab\s*-?\s*grown|labgrown/i.test(diamondTypeRaw)) {
      diamondType = "labgrown";
    } else if (diamondTypeRaw && /natural/i.test(diamondTypeRaw)) {
      diamondType = "natural";
    }

    var colourModeRaw = getUrlParam(params, "ColourMode").toLowerCase();
    var colourMode = colourModeRaw === "fancy" ? "fancy" : "white";
    if (
      diamondType === "labgrown_colour" ||
      getUrlParam(params, "FancyColor") ||
      getUrlParam(params, "FancyIntensity") ||
      getUrlParam(params, "FancyOvertone")
    ) {
      colourMode = "fancy";
    }

    return {
      shape: shapeFromUrlValue(getUrlParam(params, "Shape")),
      price_min: getUrlParam(params, "PriceFrom"),
      price_max: getUrlParam(params, "PriceTo"),
      carat_min: getUrlParam(params, "CaratFrom"),
      carat_max: getUrlParam(params, "CaratTo"),
      color: getUrlParam(params, "Color").toUpperCase(),
      colour_mode: colourMode,
      fancy_color: getUrlParam(params, "FancyColor"),
      fancy_intensity: getUrlParam(params, "FancyIntensity"),
      fancy_overtone: getUrlParam(params, "FancyOvertone"),
      cut: getUrlParam(params, "Cut").toUpperCase(),
      clarity: getUrlParam(params, "Clarity").toUpperCase(),
      polish: getUrlParam(params, "Polish").toUpperCase(),
      symmetry: getUrlParam(params, "Symmetry").toUpperCase(),
      fluorescence: getUrlParam(params, "Fluorescence").toUpperCase(),
      certificate_lab: getUrlParam(params, "Report").toUpperCase(),
      depth_min: getUrlParam(params, "DepthFrom"),
      depth_max: getUrlParam(params, "DepthTo"),
      table_min: getUrlParam(params, "TableFrom"),
      table_max: getUrlParam(params, "TableTo"),
      ratio_min: getUrlParam(params, "RatioFrom"),
      ratio_max: getUrlParam(params, "RatioTo"),
      cert_number: getUrlParam(params, "CertNumber") || getUrlParam(params, "diamondId"),
      diamond_type: diamondType,
      sort: normalizeDiamondSort(getUrlParam(params, "Sort")),
    };
  }

  function filtersToUrlSearchParams(filters) {
    var configuredDefaults = getFilterDefaults();
    var next = new URLSearchParams();
    var current = new URLSearchParams(window.location.search);

    RESERVED_QUERY_KEYS.forEach(function (key) {
      var val = current.get(key);
      if (val) next.set(key, val);
    });

    if (filters.shape) next.set("Shape", shapeToUrlValue(filters.shape));

    if (!isFullRange(filters.price_min, filters.price_max, configuredDefaults.priceMin, configuredDefaults.priceMax)) {
      if (filters.price_min) next.set("PriceFrom", String(filters.price_min));
      if (filters.price_max) next.set("PriceTo", String(filters.price_max));
    }

    if (!isFullRange(filters.carat_min, filters.carat_max, configuredDefaults.caratMin, configuredDefaults.caratMax)) {
      if (filters.carat_min) next.set("CaratFrom", String(filters.carat_min));
      if (filters.carat_max) next.set("CaratTo", String(filters.carat_max));
    }

    if (filters.diamond_type === "labgrown_colour") {
      next.set("DiamondType", "Colored");
    } else if (filters.diamond_type === "labgrown") {
      next.set("DiamondType", "LabGrown");
    } else if (filters.diamond_type === "natural") {
      next.set("DiamondType", "Natural");
    }

    if (filters.colour_mode === "fancy") {
      next.set("ColourMode", "Fancy");
      if (filters.fancy_color) next.set("FancyColor", formatFancyColorForApi(filters.fancy_color));
      if (filters.fancy_intensity) next.set("FancyIntensity", formatFancyIntensityForApi(filters.fancy_intensity));
      if (filters.fancy_overtone) next.set("FancyOvertone", formatFancyOvertoneForApi(filters.fancy_overtone));
    } else {
      if (filters.colour_mode === "white") next.set("ColourMode", "White");
      if (filters.color) next.set("Color", filters.color);
    }
    if (filters.clarity) next.set("Clarity", filters.clarity);
    if (filters.cut) next.set("Cut", filters.cut);
    if (filters.polish) next.set("Polish", filters.polish);
    if (filters.symmetry) next.set("Symmetry", filters.symmetry);
    if (filters.fluorescence) next.set("Fluorescence", filters.fluorescence);
    if (filters.certificate_lab) next.set("Report", filters.certificate_lab);

    if (!isFullRange(filters.depth_min, filters.depth_max, FILTER_DEFAULTS.depth_min, FILTER_DEFAULTS.depth_max)) {
      if (filters.depth_min) next.set("DepthFrom", String(filters.depth_min));
      if (filters.depth_max) next.set("DepthTo", String(filters.depth_max));
    }

    if (!isFullRange(filters.table_min, filters.table_max, FILTER_DEFAULTS.table_min, FILTER_DEFAULTS.table_max)) {
      if (filters.table_min) next.set("TableFrom", String(filters.table_min));
      if (filters.table_max) next.set("TableTo", String(filters.table_max));
    }

    if (!isFullRange(filters.ratio_min, filters.ratio_max, FILTER_DEFAULTS.ratio_min, FILTER_DEFAULTS.ratio_max)) {
      if (filters.ratio_min) next.set("RatioFrom", String(filters.ratio_min));
      if (filters.ratio_max) next.set("RatioTo", String(filters.ratio_max));
    }

    if (filters.cert_number) next.set("CertNumber", filters.cert_number);

    next.set("Sort", normalizeDiamondSort(filters.sort));

    return next;
  }

  function syncFiltersToUrl(filters) {
    var currentFilters = filters || getFilters();
    persistFilters(currentFilters);
    var params = filtersToUrlSearchParams(currentFilters);
    params.delete("diamondId");
    if (state.openDiamondId) {
      params.set("diamondId", state.openDiamondId);
      if (!params.get("CertNumber")) params.set("CertNumber", state.openDiamondId);
    }
    var url = new URL(window.location.href);
    var qs = params.toString();
    var nextUrl = url.pathname + (qs ? "?" + qs : "") + url.hash;
    if (nextUrl === url.pathname + url.search + url.hash) return;
    history.replaceState(history.state || {}, "", nextUrl);
  }

  function syncUrlFromUi() {
    syncFiltersToUrl(getFilters());
  }

  function markFiltersEdited() {
    state.userHasEditedFilters = true;
    var root = getRoot();
    if (root) root.dataset.filtersBootstrapped = "true";
  }

  function cancelScheduledFilterReload() {
    if (state.reloadTimer) {
      clearTimeout(state.reloadTimer);
      state.reloadTimer = null;
    }
  }

  /**
   * Keep the URL in sync on every UI change, but coalesce rapid multi-selects
   * (Colour D→E→F, Clarity, etc.) into one API request with the final CSV.
   */
  function scheduleFilterReload() {
    markFiltersEdited();
    syncUrlFromUi();
    cancelScheduledFilterReload();
    state.reloadTimer = setTimeout(function () {
      state.reloadTimer = null;
      loadDiamonds(false);
    }, FILTER_RELOAD_DEBOUNCE_MS);
  }

  function flushFilterReload() {
    cancelScheduledFilterReload();
    syncUrlFromUi();
    return loadDiamonds(false);
  }

  function setPillGroupValues(groupKey, valuesCsv) {
    var root = getRoot();
    if (!root) return;
    var group = root.querySelector('[data-diamond-pill-group="' + groupKey + '"]');
    if (!group) return;
    var values = valuesCsv
      ? valuesCsv.split(",").map(function (v) {
          return v.trim().toUpperCase();
        })
      : [];
    group.querySelectorAll(".rb-filter-pill").forEach(function (pill) {
      var val = (pill.getAttribute("data-pill-value") || "").toUpperCase();
      pill.classList.toggle("is-active", values.indexOf(val) !== -1);
    });
    syncPillHiddenInput(group);
  }

  function setCheckboxGroupValues(groupKey, valuesCsv) {
    var root = getRoot();
    if (!root) return;
    var group = root.querySelector('[data-diamond-checkbox-group="' + groupKey + '"]');
    if (!group) return;
    var values = valuesCsv
      ? valuesCsv.split(",").map(function (v) {
          return v.trim().toUpperCase();
        })
      : [];
    group.querySelectorAll(".rb-filter-checkbox__input").forEach(function (cb) {
      cb.checked = values.indexOf(String(cb.value).toUpperCase()) !== -1;
    });
    syncCheckboxHiddenInput(group);
  }

  function applyShapeFilter(shapeApi) {
    var root = getRoot();
    if (!root) return;
    var normalized = shapeApi ? String(shapeApi).toUpperCase() : "";
    var matchedBtn = null;
    root.querySelectorAll("[data-diamond-shape-swatch]").forEach(function (btn) {
      var shape = (btn.getAttribute("data-shape") || "").toUpperCase();
      var active = !!(normalized && shapesMatch(shape, normalized));
      btn.classList.toggle("is-active", active);
      btn.classList.toggle("is-selected", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      var swatch = btn.querySelector(".diamond-shape-swatch");
      if (swatch) {
        swatch.classList.toggle("is-active", active);
        swatch.classList.toggle("diamond-shape-swatch--current", active);
      }
      if (active) matchedBtn = btn;
    });
    var hidden = root.querySelector('[data-diamond-filter="shape"]');
    if (hidden) {
      // Prefer full multi-value mapping from the matched customization swatch.
      hidden.value = matchedBtn
        ? (matchedBtn.getAttribute("data-shape") || "").toUpperCase()
        : normalized;
    }

    if (matchedBtn) {
      matchedBtn.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }

  function setSliderRange(sliderId, minVal, maxVal, fallbackMin, fallbackMax) {
    var root = getRoot();
    var slider = root.querySelector(sliderId);
    if (!slider || !slider.noUiSlider) return;
    var min = parseFloat(minVal);
    var max = parseFloat(maxVal);
    if (!isFinite(min)) min = fallbackMin;
    if (!isFinite(max)) max = fallbackMax;
    slider.noUiSlider.set([min, max]);
  }

  function applyAdvancedRange(minKey, maxKey, sliderId, minVal, maxVal, defMin, defMax) {
    var root = getRoot();
    if (!minVal && !maxVal) return;
    var minInput = root.querySelector('[data-diamond-filter="' + minKey + '"]');
    var maxInput = root.querySelector('[data-diamond-filter="' + maxKey + '"]');
    if (minInput) minInput.value = minVal || "";
    if (maxInput) maxInput.value = maxVal || "";
    setSliderRange(sliderId, minVal || defMin, maxVal || defMax, defMin, defMax);
  }

  function applyFiltersToUi(filters) {
    var root = getRoot();
    if (!root || !filters) return;

    if (filters.diamond_type === "labgrown_colour") {
      setDiamondType("labgrown_colour");
    } else if (filters.diamond_type === "labgrown") {
      setDiamondType("labgrown");
    } else {
      setDiamondType("natural");
    }

    applyShapeFilter(filters.shape);

    if (filters.price_min || filters.price_max) {
      var priceDefaults = getFilterDefaults();
      var priceMin = filters.price_min || priceDefaults.priceMin;
      var priceMax = filters.price_max || priceDefaults.priceMax;
      var priceMinInput = root.querySelector('[data-diamond-filter="price_min"]');
      var priceMaxInput = root.querySelector('[data-diamond-filter="price_max"]');
      if (priceMinInput) priceMinInput.value = priceMin;
      if (priceMaxInput) priceMaxInput.value = priceMax;
      root.querySelectorAll('[data-diamond-range="price_min"]').forEach(function (el) {
        el.value = priceMin;
      });
      root.querySelectorAll('[data-diamond-range="price_max"]').forEach(function (el) {
        el.value = priceMax;
      });
      setSliderRange("#price-slider", priceMin, priceMax, priceDefaults.priceMin, priceDefaults.priceMax);
    }
    if (filters.carat_min || filters.carat_max) {
      var caratDefaults = getFilterDefaults();
      setSliderRange(
        "#carat-slider",
        filters.carat_min || caratDefaults.caratMin,
        filters.carat_max || caratDefaults.caratMax,
        caratDefaults.caratMin,
        caratDefaults.caratMax,
      );
    }

    if (filters.colour_mode === "fancy") {
      applyColourModeUi("fancy");
      setFancySelectValues(filters.fancy_color, filters.fancy_intensity, filters.fancy_overtone);
    } else {
      applyColourModeUi("white");
      if (filters.color) setPillGroupValues("color", filters.color);
    }

    setPillGroupValues("cut", filters.cut);
    setPillGroupValues("clarity", filters.clarity);
    setPillGroupValues("polish", filters.polish);
    setPillGroupValues("symmetry", filters.symmetry);
    setPillGroupValues("fluorescence", filters.fluorescence);
    setCheckboxGroupValues("certificate_lab", filters.certificate_lab);

    applyAdvancedRange(
      "depth_min",
      "depth_max",
      "#depth-slider",
      filters.depth_min,
      filters.depth_max,
      30,
      90,
    );
    applyAdvancedRange(
      "ratio_min",
      "ratio_max",
      "#ratio-slider",
      filters.ratio_min,
      filters.ratio_max,
      0.8,
      2.5,
    );
    applyAdvancedRange(
      "table_min",
      "table_max",
      "#table-slider",
      filters.table_min,
      filters.table_max,
      30,
      90,
    );

    var certInput = root.querySelector("#diamond-filter-cert-number");
    if (certInput && filters.cert_number) certInput.value = filters.cert_number;

    applySortFilter(filters.sort || getDefaultDiamondSort());

    var hasAdvanced =
      filters.depth_min ||
      filters.depth_max ||
      filters.ratio_min ||
      filters.ratio_max ||
      filters.table_min ||
      filters.table_max ||
      filters.polish ||
      filters.symmetry ||
      filters.fluorescence ||
      filters.certificate_lab;
    if (hasAdvanced) {
      var advancedToggle = root.querySelector("[data-diamond-advanced-toggle]");
      var advancedPanel = root.querySelector("[data-diamond-advanced-panel]");
      if (advancedToggle && advancedPanel) {
        advancedPanel.hidden = false;
        advancedToggle.setAttribute("aria-expanded", "true");
      }
    }
  }

  function formatFancyEnumLabel(value) {
    if (!value) return "";
    return String(value)
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  // Nivoda API expects Title Case fancy filter strings (see API guide Section 8.6).
  var FANCY_COLOR_API_LABELS = {
    BI_COLOR: "Bi-color",
    MULTI_COLOR: "Multi-color",
    SALT_AND_PEPPER: "Salt and Pepper",
  };

  var FANCY_OVERTONE_API_LABELS = {
    ORANGY: "Orangey",
    ORANGEY: "Orangey",
  };

  var FANCY_INTENSITY_API_VALUES = {
    FAINT: "Faint",
    VERY_LIGHT: "Very_Light",
    LIGHT: "Light",
    FANCY_LIGHT: "Fancy_Light",
    FANCY: "Fancy",
    FANCY_DARK: "Fancy_Dark",
    FANCY_INTENSE: "Fancy_Intense",
    FANCY_VIVID: "Fancy_Vivid",
    FANCY_DEEP: "Fancy_Deep",
  };

  function formatFancyColorForApi(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var key = raw.toUpperCase();
    if (FANCY_COLOR_API_LABELS[key]) return FANCY_COLOR_API_LABELS[key];
    if (raw.indexOf("_") !== -1) {
      return raw
        .toLowerCase()
        .split("_")
        .map(function (part) {
          return part.charAt(0).toUpperCase() + part.slice(1);
        })
        .join(" ");
    }
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  function formatFancyOvertoneForApi(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var key = raw.toUpperCase();
    if (FANCY_OVERTONE_API_LABELS[key]) return FANCY_OVERTONE_API_LABELS[key];
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  function formatFancyIntensityForApi(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var key = raw.replace(/\s+/g, "_").toUpperCase();
    if (FANCY_INTENSITY_API_VALUES[key]) return FANCY_INTENSITY_API_VALUES[key];
    var docValues = Object.keys(FANCY_INTENSITY_API_VALUES).map(function (k) {
      return FANCY_INTENSITY_API_VALUES[k];
    });
    if (docValues.indexOf(raw) !== -1) return raw;
    return raw.replace(/\s+/g, "_");
  }

  function setSelectValue(select, value) {
    if (!select) return;
    if (!value) {
      select.value = "";
      return;
    }
    select.value = value;
    if (select.value === value) return;
    var normalized = String(value).toUpperCase();
    for (var i = 0; i < select.options.length; i++) {
      if (String(select.options[i].value).toUpperCase() === normalized) {
        select.value = select.options[i].value;
        return;
      }
    }
  }

  function clearWhiteColourFilters() {
    var root = getRoot();
    if (!root) return;
    var colourPillGroup = root.querySelector('[data-diamond-pill-group="color"]');
    if (!colourPillGroup) return;
    colourPillGroup.querySelectorAll(".rb-filter-pill.is-active").forEach(function (pill) {
      pill.classList.remove("is-active");
    });
    syncPillHiddenInput(colourPillGroup);
  }

  function clearFancyColourFilters() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll("[data-fancy-select]").forEach(function (select) {
      select.value = "";
    });
  }

  function applyColourModeUi(mode) {
    var root = getRoot();
    if (!root) return;
    var isFancy = mode === "fancy";
    var colourFilter = root.querySelector("[data-colour-filter]");
    if (colourFilter) {
      colourFilter.setAttribute("data-colour-mode", isFancy ? "fancy" : "white");
    }
    var colourModeInput = root.querySelector('[data-diamond-filter="colour_mode"]');
    if (colourModeInput) colourModeInput.value = isFancy ? "fancy" : "white";

    root.querySelectorAll("[data-colour-mode]").forEach(function (btn) {
      var btnMode = btn.getAttribute("data-colour-mode");
      var active = btnMode === (isFancy ? "fancy" : "white");
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    var whitePanel = root.querySelector('[data-colour-panel="white"]');
    var fancyPanel = root.querySelector('[data-colour-panel="fancy"]');
    if (whitePanel) whitePanel.hidden = isFancy;
    if (fancyPanel) fancyPanel.hidden = !isFancy;
  }

  function setFancySelectValues(color, intensity, overtone) {
    var root = getRoot();
    if (!root) return;
    var colorSelect = root.querySelector('[data-fancy-select="color"]');
    var intensitySelect = root.querySelector('[data-fancy-select="intensity"]');
    var overtoneSelect = root.querySelector('[data-fancy-select="overtone"]');
    if (colorSelect) setSelectValue(colorSelect, color || "");
    if (intensitySelect) setSelectValue(intensitySelect, intensity || "");
    if (overtoneSelect) setSelectValue(overtoneSelect, overtone || "");
  }

  function getDiamondFilterOptionsConfig() {
    var el = document.getElementById("DiamondFilterOptionsConfig");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getFilterDefaults() {
    var config = getDiamondFilterOptionsConfig();
    var defaults = config && config.defaults ? config.defaults : {};
    var priceFloor = defaults.priceFloor != null ? Number(defaults.priceFloor) : 0;
    if (!isFinite(priceFloor) || priceFloor < 0) priceFloor = 0;
    var priceMin = defaults.priceMin != null ? Number(defaults.priceMin) : 1;
    var priceMax = defaults.priceMax != null ? Number(defaults.priceMax) : 150000;
    if (!isFinite(priceMin)) priceMin = 1;
    if (!isFinite(priceMax)) priceMax = 150000;
    // Default start must stay within the absolute slider floor/ceiling.
    if (priceMin < priceFloor) priceMin = priceFloor;
    return {
      priceFloor: priceFloor,
      priceMin: priceMin,
      priceMax: priceMax,
      caratMin: defaults.caratMin != null ? parseFloat(defaults.caratMin) : 0.01,
      caratMax: defaults.caratMax != null ? parseFloat(defaults.caratMax) : 10.00
    };
  }

  function parseOptionsRaw(raw) {
    if (!raw || typeof raw !== "string") return [];
    return raw
      .split(/[,\n]/)
      .map(function (entry) {
        return entry.trim();
      })
      .filter(Boolean)
      .map(function (entry) {
        var parts = entry.split("|");
        var label = (parts[0] || "").trim();
        var value = (parts[1] || parts[0] || "").trim();
        return { label: label, value: value };
      });
  }

  function populateFancySelect(selectKey, values, placeholder) {
    var root = getRoot();
    if (!root || !values || !values.length) return;
    var select = root.querySelector('[data-fancy-select="' + selectKey + '"]');
    if (!select || select.dataset.optionsLoaded === "true") return;
    var currentValue = select.value;
    select.innerHTML = "";
    var blank = document.createElement("option");
    blank.value = "";
    blank.textContent = placeholder;
    select.appendChild(blank);
    values.forEach(function (item) {
      var option = document.createElement("option");
      if (item && typeof item === "object" && item.value != null) {
        option.value = item.value;
        option.textContent = item.label || formatFancyEnumLabel(item.value);
      } else {
        option.value = item;
        option.textContent = formatFancyEnumLabel(item);
      }
      select.appendChild(option);
    });
    if (currentValue) select.value = currentValue;
    select.dataset.optionsLoaded = "true";
  }

  function loadFancyFilterOptions() {
    var root = getRoot();
    if (!root || root.dataset.fancyOptionsLoaded === "true") return Promise.resolve();

    var config = getDiamondFilterOptionsConfig();
    var fancyCfg = config && config.fancy ? config.fancy : {};
    var colorPlaceholder = fancyCfg.colorPlaceholder || "Select colour";
    var intensityPlaceholder = fancyCfg.intensityPlaceholder || "Select intensity";
    var overtonePlaceholder = fancyCfg.overtonePlaceholder || "Select overtone";

    function populateFromThemeLists() {
      var colors = parseOptionsRaw(fancyCfg.colorsRaw);
      var intensities = parseOptionsRaw(fancyCfg.intensitiesRaw);
      var overtones = parseOptionsRaw(fancyCfg.overtonesRaw);
      populateFancySelect("color", colors.length ? colors : parseOptionsRaw("Yellow|Yellow,Pink|Pink,Blue|Blue,Red|Red,Green|Green,Purple|Purple,Orange|Orange,Violet|Violet,Gray|Gray,Black|Black,Brown|Brown,Champagne|Champagne,Cognac|Cognac,Chameleon|Chameleon,White|White,Other|Other,Salt and Pepper|Salt and Pepper"), colorPlaceholder);
      populateFancySelect("intensity", intensities.length ? intensities : parseOptionsRaw("Faint|Faint,Very Light|Very_Light,Light|Light,Fancy Light|Fancy_Light,Fancy|Fancy,Fancy Dark|Fancy_Dark,Fancy Intense|Fancy_Intense,Fancy Vivid|Fancy_Vivid,Fancy Deep|Fancy_Deep"), intensityPlaceholder);
      populateFancySelect("overtone", overtones.length ? overtones : parseOptionsRaw("None|None,Yellow|Yellow,Yellowish|Yellowish,Pink|Pink,Pinkish|Pinkish,Blue|Blue,Blueish|Blueish,Red|Red,Reddish|Reddish,Green|Green,Greenish|Greenish,Purple|Purple,Purplish|Purplish,Orange|Orange,Orangey|Orangey,Violet|Violet,Gray|Gray,Grayish|Grayish,Black|Black,Brown|Brown,Brownish|Brownish,Champagne|Champagne,Cognac|Cognac,Chameleon|Chameleon,White|White,Other|Other"), overtonePlaceholder);
      root.dataset.fancyOptionsLoaded = "true";
    }

    if (fancyCfg.useCustom) {
      populateFromThemeLists();
      return Promise.resolve();
    }

    var url = getProxyBaseUrl() + "/diamond-filter-options";
    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to load fancy filter options");
        return response.json();
      })
      .then(function (options) {
        populateFancySelect("color", options.fancy_colors, colorPlaceholder);
        populateFancySelect("intensity", options.fancy_intensities, intensityPlaceholder);
        populateFancySelect("overtone", options.fancy_overtones, overtonePlaceholder);
        root.dataset.fancyOptionsLoaded = "true";
      })
      .catch(function () {
        populateFromThemeLists();
      });
  }

  function normalizeDiamondType(type) {
    if (type === "labgrown_colour" || type === "fancy") return "labgrown_colour";
    if (type === "labgrown") return "labgrown";
    if (type === "natural") return "natural";
    return "labgrown";
  }

  function getDefaultDiamondType() {
    var root = getRoot();
    if (!root) return "labgrown";
    var diamondTypeInput = root.querySelector('[data-diamond-filter="diamond_type"]');
    if (diamondTypeInput) {
      var fromData = diamondTypeInput.getAttribute("data-default-diamond-type");
      if (fromData) return normalizeDiamondType(fromData);
      if (diamondTypeInput.value) return normalizeDiamondType(diamondTypeInput.value);
    }
    var labgrownBtn = root.querySelector('.ring-builder-diamond-type-btn[data-diamond-type="labgrown"]');
    if (labgrownBtn) return "labgrown";
    var colourBtn = root.querySelector('.ring-builder-diamond-type-btn[data-diamond-type="labgrown_colour"]');
    if (colourBtn) return "labgrown_colour";
    return "natural";
  }

  function setDiamondType(type, options) {
    options = options || {};
    var root = getRoot();
    if (!root) return;

    var diamondType = normalizeDiamondType(type);
    var labgrownInput = root.querySelector('[data-diamond-filter="labgrown"]');
    var diamondTypeInput = root.querySelector('[data-diamond-filter="diamond_type"]');

    root.querySelectorAll(".ring-builder-diamond-type-btn").forEach(function (btn) {
      btn.classList.toggle("is-active", btn.getAttribute("data-diamond-type") === diamondType);
    });

    if (labgrownInput) {
      labgrownInput.value = diamondType === "natural" ? "false" : "true";
    }
    if (diamondTypeInput) {
      diamondTypeInput.value = diamondType;
    }

    if (diamondType === "labgrown_colour" && !options.skipColourMode) {
      clearWhiteColourFilters();
      applyColourModeUi("fancy");
    }
  }

  function setColourMode(mode) {
    var root = getRoot();
    if (!root) return;

    var nextMode = mode === "fancy" ? "fancy" : "white";
    if (nextMode === "fancy") {
      clearWhiteColourFilters();
    } else {
      clearFancyColourFilters();
      var diamondTypeInput = root.querySelector('[data-diamond-filter="diamond_type"]');
      if (diamondTypeInput && diamondTypeInput.value === "labgrown_colour") {
        setDiamondType("labgrown", { skipColourMode: true });
      }
    }

    applyColourModeUi(nextMode);
  }

  function getFilters() {
    var root = getRoot();
    if (!root) return {};

    var shapeInput = root.querySelector('[data-diamond-filter="shape"]');
    var caratMinInput = root.querySelector('[data-diamond-filter="carat_min"]');
    var caratMaxInput = root.querySelector('[data-diamond-filter="carat_max"]');
    var colorInput = root.querySelector('[data-diamond-filter="color"]');
    var colourModeInput = root.querySelector('[data-diamond-filter="colour_mode"]');
    var fancyColorInput = root.querySelector('[data-diamond-filter="fancy_color"]');
    var fancyIntensityInput = root.querySelector('[data-diamond-filter="fancy_intensity"]');
    var fancyOvertoneInput = root.querySelector('[data-diamond-filter="fancy_overtone"]');
    var clarityInput = root.querySelector('[data-diamond-filter="clarity"]');
    var priceMinInput = root.querySelector('[data-diamond-filter="price_min"]');
    var priceMaxInput = root.querySelector('[data-diamond-filter="price_max"]');
    var labgrownInput = root.querySelector('[data-diamond-filter="labgrown"]');
    var diamondTypeInput = root.querySelector('[data-diamond-filter="diamond_type"]');
    var certInput = root.querySelector('#diamond-filter-cert-number');
    var cutInput = root.querySelector('[data-diamond-filter="cut"]');
    var polishInput = root.querySelector('[data-diamond-filter="polish"]');
    var symmetryInput = root.querySelector('[data-diamond-filter="symmetry"]');
    var fluorescenceInput = root.querySelector('[data-diamond-filter="fluorescence"]');
    var certificateLabInput = root.querySelector('[data-diamond-filter="certificate_lab"]');
    var labgrownTypeInput = root.querySelector('[data-diamond-filter="labgrown_type"]');
    var tableMinInput = root.querySelector('[data-diamond-filter="table_min"]');
    var tableMaxInput = root.querySelector('[data-diamond-filter="table_max"]');
    var ratioMinInput = root.querySelector('[data-diamond-filter="ratio_min"]');
    var ratioMaxInput = root.querySelector('[data-diamond-filter="ratio_max"]');
    var depthMinInput = root.querySelector('[data-diamond-filter="depth_min"]');
    var depthMaxInput = root.querySelector('[data-diamond-filter="depth_max"]');
    var sortInput = root.querySelector('[data-diamond-filter="sort"]');

    var diamondType = diamondTypeInput ? diamondTypeInput.value : getDefaultDiamondType();
    diamondType = normalizeDiamondType(diamondType);
    var colourMode = colourModeInput ? colourModeInput.value : "white";
    if (diamondType === "labgrown_colour") colourMode = "fancy";

    return {
      shape: shapeInput ? shapeInput.value : "",
      carat_min: caratMinInput ? caratMinInput.value : "",
      carat_max: caratMaxInput ? caratMaxInput.value : "",
      color: colorInput ? colorInput.value : "",
      colour_mode: colourMode === "fancy" ? "fancy" : "white",
      fancy_color: fancyColorInput ? fancyColorInput.value : "",
      fancy_intensity: fancyIntensityInput ? fancyIntensityInput.value : "",
      fancy_overtone: fancyOvertoneInput ? fancyOvertoneInput.value : "",
      clarity: clarityInput ? clarityInput.value : "",
      price_min: priceMinInput ? priceMinInput.value : "",
      price_max: priceMaxInput ? priceMaxInput.value : "",
      labgrown: diamondType === "natural" ? "false" : "true",
      diamond_type: diamondType,
      cert_number: certInput ? certInput.value : "",
      cut: cutInput ? cutInput.value : "",
      polish: polishInput ? polishInput.value : "",
      symmetry: symmetryInput ? symmetryInput.value : "",
      fluorescence: fluorescenceInput ? fluorescenceInput.value : "",
      certificate_lab: certificateLabInput ? certificateLabInput.value : "",
      labgrown_type: labgrownTypeInput ? labgrownTypeInput.value : "",
      table_min: tableMinInput ? tableMinInput.value : "",
      table_max: tableMaxInput ? tableMaxInput.value : "",
      ratio_min: ratioMinInput ? ratioMinInput.value : "",
      ratio_max: ratioMaxInput ? ratioMaxInput.value : "",
      depth_min: depthMinInput ? depthMinInput.value : "",
      depth_max: depthMaxInput ? depthMaxInput.value : "",
      sort: normalizeDiamondSort(sortInput ? sortInput.value : getDefaultDiamondSort()),
    };
  }

  function clearFilters() {
    var root = getRoot();
    if (!root) return;

    var shapeInput = root.querySelector('[data-diamond-filter="shape"]');
    if (shapeInput) shapeInput.value = "";

    // Reset shape swatches
    root.querySelectorAll('[data-diamond-shape-swatch]').forEach(function (btn) {
      btn.classList.remove('is-active', 'is-selected');
      btn.setAttribute('aria-pressed', 'false');
      var swatch = btn.querySelector('.diamond-shape-swatch');
      if (swatch) {
        swatch.classList.remove('is-active', 'diamond-shape-swatch--current');
      }
    });

    var certInput = root.querySelector('#diamond-filter-cert-number');
    if (certInput) certInput.value = "";

    // Reset sliders
    var filterDefaults = getFilterDefaults();
    var caratSlider = root.querySelector('#carat-slider');
    if (caratSlider && caratSlider.noUiSlider) {
      caratSlider.noUiSlider.set([filterDefaults.caratMin, filterDefaults.caratMax]);
    }
    var priceSlider = root.querySelector('#price-slider');
    if (priceSlider && priceSlider.noUiSlider) {
      priceSlider.noUiSlider.set([filterDefaults.priceMin, filterDefaults.priceMax]);
    }

    var tableSlider = root.querySelector('#table-slider');
    if (tableSlider && tableSlider.noUiSlider) {
      tableSlider.noUiSlider.set([30, 90]);
    }

    var depthSlider = root.querySelector('#depth-slider');
    if (depthSlider && depthSlider.noUiSlider) {
      depthSlider.noUiSlider.set([30, 90]);
    }

    var ratioSlider = root.querySelector('#ratio-slider');
    if (ratioSlider && ratioSlider.noUiSlider) {
      ratioSlider.noUiSlider.set([0.8, 2.5]);
    }

    root.querySelectorAll('.rb-filter-pill.is-active').forEach(function (pill) {
      pill.classList.remove('is-active');
    });
    root.querySelectorAll('[data-diamond-pill-group]').forEach(function (group) {
      syncPillHiddenInput(group);
    });

    root.querySelectorAll('[data-diamond-checkbox-group]').forEach(function (group) {
      group.querySelectorAll('.rb-filter-checkbox__input').forEach(function (checkbox) {
        checkbox.checked = false;
      });
      syncCheckboxHiddenInput(group);
    });

    root.querySelectorAll('[data-diamond-filter="table_min"], [data-diamond-filter="table_max"], [data-diamond-filter="ratio_min"], [data-diamond-filter="ratio_max"], [data-diamond-filter="depth_min"], [data-diamond-filter="depth_max"]').forEach(function (input) {
      input.value = "";
    });

    setDiamondType(getDefaultDiamondType());
    applyColourModeUi("white");
    clearFancyColourFilters();

    var shapeGrid = root.querySelector('[data-diamond-shape-grid]');
    if (shapeGrid) shapeGrid.classList.remove('is-expanded');

    root.querySelectorAll('[data-diamond-range]').forEach(function (input) {
      var key = input.getAttribute('data-diamond-range');
      var hidden = root.querySelector('[data-diamond-filter="' + key + '"]');
      if (hidden && hidden.value !== "") {
        input.value = hidden.value;
      }
    });

    syncFiltersToUrl(getFilters());
  }

  function clearResults() {
    var tbody = getTableBody();
    var grid = getGrid();
    if (tbody) tbody.innerHTML = "";
    if (grid) grid.innerHTML = "";
    state.apiOffset = 0;
    state.lastPageRawCount = 0;
    state.totalCount = 0;
    state.items = [];
    updateResultMeta();
  }

  function setViewMode(mode, persist) {
    var root = getRoot();
    if (!root) return;

    var nextMode = mode === "grid" ? "grid" : "table";
    state.viewMode = nextMode;
    root.setAttribute("data-view", nextMode);

    root.querySelectorAll("[data-diamond-view]").forEach(function (btn) {
      var isActive = btn.getAttribute("data-diamond-view") === nextMode;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    var grid = getGrid();
    var tableWrap = root.querySelector(".ring-builder-diamonds__table-wrap");
    var isGrid = nextMode === "grid";

    if (grid) {
      if (isGrid) {
        grid.removeAttribute("hidden");
        grid.style.removeProperty("display");
      } else {
        grid.hidden = true;
        grid.style.display = "none";
      }
    }
    if (tableWrap) {
      if (isGrid) {
        tableWrap.hidden = true;
        tableWrap.style.display = "none";
      } else {
        tableWrap.removeAttribute("hidden");
        tableWrap.style.removeProperty("display");
      }
    }

    if (persist !== false) {
      try {
        localStorage.setItem(VIEW_STORAGE_KEY, nextMode);
      } catch (e) {}
    }
  }

  function restoreViewMode() {
    try {
      var saved = localStorage.getItem(VIEW_STORAGE_KEY);
      if (saved === "grid" || saved === "table") {
        setViewMode(saved, false);
        return;
      }
    } catch (e) {}
    setViewMode("grid", false);
  }

  function setPanelMessage(message, isError) {
    var root = getRoot();
    if (!root) return;

    var notice = root.querySelector("[data-diamond-notice]");
    if (!notice) return;

    notice.textContent = message || "";
    notice.hidden = !message;
    notice.classList.toggle("ring-builder-diamonds__notice--error", !!isError);
  }

  function getSkeletonCount() {
    var config = getConfig();
    var cls = config.gridClass || "";
    if (cls.indexOf("col-lg-3") !== -1 || cls.indexOf("col-lg-2") !== -1) return 8;
    if (cls.indexOf("col-lg-4") !== -1) return 6;
    return 8;
  }

  function renderSkeletonCards(count) {
    var grid = getGrid();
    var template = document.getElementById("diamond-card-skeleton-template");
    if (!grid || !template || !template.content) return;

    var config = getConfig();
    var total = count || getSkeletonCount();
    var fragment = document.createDocumentFragment();

    for (var i = 0; i < total; i++) {
      var node = template.content.firstElementChild.cloneNode(true);
      if (config.gridClass) {
        config.gridClass.split(/\s+/).forEach(function (cls) {
          if (cls) node.classList.add(cls);
        });
      }
      fragment.appendChild(node);
    }

    grid.appendChild(fragment);
  }

  function clearSkeletonCards() {
    var grid = getGrid();
    if (!grid) return;
    grid.querySelectorAll("[data-diamond-skeleton]").forEach(function (node) {
      node.remove();
    });
  }

  function updateLoadingUi(isLoading, append) {
    var root = getRoot();
    if (!root) return;

    var skeleton = root.querySelector("[data-diamond-skeleton]");
    var results = root.querySelector(".ring-builder-diamonds__results");
    var resultsHeader = root.querySelector(".ring-builder-diamonds__results-header");
    var loadMoreBtn = root.querySelector("[data-diamond-load-more]");
    var loadingText = root.querySelector("[data-diamond-loading]");

    if (isLoading) {
      if (root.classList.contains("is-diamond-detail-open") || isDiamondDetailOpen()) {
        hideDiamondSearchLayout(root);
        return;
      }
      root.classList.add("is-loading-initial");
      if (loadingText) loadingText.hidden = true;

      if (!append) {
        if (skeleton) skeleton.hidden = false;
        if (results) results.style.display = "none";
        if (resultsHeader) resultsHeader.style.display = "none";
      } else if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "Loading more diamonds...";
      }

      return;
    }

    root.classList.remove("is-loading-initial");
    if (skeleton) skeleton.hidden = true;
    if (loadingText) loadingText.hidden = true;

    if (root.classList.contains("is-diamond-detail-open") || isDiamondDetailOpen()) {
      hideDiamondSearchLayout(root);
    } else {
      if (results) results.style.display = "";
      if (resultsHeader) resultsHeader.style.display = "";
    }

    if (loadMoreBtn) {
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = LOAD_MORE_LABEL;
    }
  }

  function setLoading(isLoading, append) {
    var root = getRoot();
    if (!root) return;
    state.loading = isLoading;
    updateLoadingUi(isLoading, append);
  }

  function buildProxyUrl(filters, offset, limit) {
    var config = getConfig();
    var configuredDefaults = getFilterDefaults();
    var diamondType = normalizeDiamondType(filters.diamond_type || getDefaultDiamondType());
    var fetchLimit = parseFetchLimit(limit, getFetchLimit(false));
    var params = new URLSearchParams({
      offset: String(offset),
      limit: String(fetchLimit),
      labgrown: diamondType === "natural" ? "false" : "true",
      diamond_type: diamondType,
    });

    // Certificate lookup: send cert only so browse filters cannot hide the stone.
    if (filters.cert_number && String(filters.cert_number).trim()) {
      params.set("cert_number", String(filters.cert_number).trim());
      params.set("sort", normalizeDiamondSort(filters.sort));
      if (config.usesDirectDevProxy) {
        var shopForCert = getShopDomain();
        if (shopForCert) params.set("shop", shopForCert);
      }
      return config.proxyUrl + "?" + params.toString();
    }

    if (filters.shape) params.set("shape", normalizeShapeApiValue(filters.shape));
    if (!isFullRange(filters.carat_min, filters.carat_max, configuredDefaults.caratMin, configuredDefaults.caratMax)) {
      if (filters.carat_min) params.set("carat_min", filters.carat_min);
      if (filters.carat_max) params.set("carat_max", filters.carat_max);
    }
    var hasFancyFilters = !!(filters.fancy_color || filters.fancy_intensity || filters.fancy_overtone);
    if (filters.colour_mode === "fancy" || diamondType === "labgrown_colour" || hasFancyFilters) {
      params.set("colour_mode", "fancy");
      if (filters.fancy_color) {
        params.set("fancy_color", formatFancyColorForApi(filters.fancy_color));
      }
      if (filters.fancy_intensity) {
        params.set("fancy_intensity", formatFancyIntensityForApi(filters.fancy_intensity));
      }
      if (filters.fancy_overtone) {
        params.set("fancy_overtone", formatFancyOvertoneForApi(filters.fancy_overtone));
      }
    } else {
      if (filters.colour_mode === "white") {
        params.set("colour_mode", "white");
      }
      if (filters.color && String(filters.color).trim()) {
        params.set("color", String(filters.color).trim().toUpperCase());
      }
    }
    if (filters.clarity) params.set("clarity", filters.clarity);
    if (filters.cut) params.set("cut", filters.cut);
    if (filters.polish) params.set("polish", filters.polish);
    if (filters.symmetry) params.set("symmetry", filters.symmetry);
    if (filters.fluorescence) params.set("fluorescence", filters.fluorescence);
    if (filters.certificate_lab) params.set("certificate_lab", filters.certificate_lab);
    if (filters.labgrown_type) params.set("labgrown_type", filters.labgrown_type);
    if (!isFullRange(filters.table_min, filters.table_max, FILTER_DEFAULTS.table_min, FILTER_DEFAULTS.table_max)) {
      if (filters.table_min) params.set("table_min", filters.table_min);
      if (filters.table_max) params.set("table_max", filters.table_max);
    }
    if (!isFullRange(filters.ratio_min, filters.ratio_max, FILTER_DEFAULTS.ratio_min, FILTER_DEFAULTS.ratio_max)) {
      if (filters.ratio_min) params.set("ratio_min", filters.ratio_min);
      if (filters.ratio_max) params.set("ratio_max", filters.ratio_max);
    }
    if (!isFullRange(filters.depth_min, filters.depth_max, FILTER_DEFAULTS.depth_min, FILTER_DEFAULTS.depth_max)) {
      if (filters.depth_min) params.set("depth_min", filters.depth_min);
      if (filters.depth_max) params.set("depth_max", filters.depth_max);
    }
    // Price is applied in the browser against the card price. The proxy's
    // price_min/price_max pair does not use that amount: $1–$550 returns
    // nothing, and $1–$600 skips cheaper stones that are still under $600.
    params.set("sort", normalizeDiamondSort(filters.sort));

    if (config.usesDirectDevProxy) {
      var shop = getShopDomain();
      if (shop) params.set("shop", shop);
    }

    return config.proxyUrl + "?" + params.toString();
  }

  function formatCutLabel(cut) {
    if (!cut) return "—";
    var normalized = String(cut).trim().toUpperCase();
    var labels = {
      EX: "EX",
      EXCELLENT: "EX",
      VG: "VG",
      VERY_GOOD: "VG",
      G: "G",
      GOOD: "G",
      F: "F",
      FAIR: "F",
      ID: "IDL",
      IDEAL: "IDL",
      IDL: "IDL",
    };
    return labels[normalized] || normalized;
  }

  function getTableShapeFallbackHtml(item) {
    var iconUrl = getShapeIconUrl(item.shape);
    if (iconUrl) {
      return (
        '<img class="ring-builder-diamonds__table-shape-img" src="' +
        escapeHtml(iconUrl) +
        '" alt="" width="20" height="20" loading="lazy">'
      );
    }

    return (
      '<span class="ring-builder-diamonds__table-shape-icon" aria-hidden="true">' +
      shapeIconSvg(item.shape) +
      "</span>"
    );
  }

  function getTableThumbHtml(item, shapeLabel) {
    var media = getCardMediaUrl(item);
    var thumbUrl = media.url || "";
    if (thumbUrl && isNivodaLoupeEmbedUrl(thumbUrl)) {
      thumbUrl = resizeNivodaEmbedUrl(thumbUrl, 96, 96);
    }

    if (thumbUrl) {
      return (
        '<img class="ring-builder-diamonds__table-diamond-img" src="' +
        escapeHtml(thumbUrl) +
        '" alt="' +
        escapeHtml(shapeLabel) +
        '" width="48" height="48" loading="lazy" data-diamond-table-image' +
        (media.sample ? ' data-diamond-table-image-sample="true"' : "") +
        (media.fallback ? ' data-diamond-table-image-fallback="true"' : "") +
        ">"
      );
    }

    return getTableShapeFallbackHtml(item);
  }

  function bindTableRowImageFallback(row, item) {
    if (!row || !item) return;
    var img = row.querySelector("[data-diamond-table-image]");
    if (!img) return;

    img.addEventListener("error", function onTableImageError() {
      img.removeEventListener("error", onTableImageError);

      if (!img.getAttribute("data-diamond-table-image-sample")) {
        var sampleUrl = getSampleDiamondImageUrl(item && item.shape);
        if (sampleUrl && img.src !== sampleUrl) {
          img.setAttribute("data-diamond-table-image-sample", "true");
          img.src = sampleUrl;
          return;
        }
      }

      if (!img.getAttribute("data-diamond-table-image-fallback")) {
        var placeholderUrl = getDiamondPlaceholderUrl();
        if (placeholderUrl && img.src !== placeholderUrl) {
          img.setAttribute("data-diamond-table-image-fallback", "true");
          img.src = placeholderUrl;
          return;
        }
      }

      var fallback = document.createElement("div");
      fallback.innerHTML = getTableShapeFallbackHtml(item);
      var replacement = fallback.firstElementChild;
      if (replacement) img.replaceWith(replacement);
    });
  }

  function renderTableRow(item) {
    var payload = escapeHtml(JSON.stringify(item));
    var shapeLabel = formatShapeLabel(item.shape);
    var iconHtml = getTableThumbHtml(item, shapeLabel);

    return (
      '<tr data-diamond-card data-offer-id="' +
      escapeHtml(item.offerId) +
      '" tabindex="0" role="row" data-diamond-select data-diamond-payload="' +
      payload +
      '">' +
      '<td><div class="ring-builder-diamonds__table-shape">' +
      iconHtml +
      '<span class="ring-builder-diamonds__table-shape-name">' +
      escapeHtml(shapeLabel) +
      "</span>" +
      "</div></td>" +
      "<td>" +
      escapeHtml(formatTableCarats(item.carats)) +
      "</td>" +
      "<td>" +
      escapeHtml(item.color || "—") +
      "</td>" +
      "<td>" +
      escapeHtml(item.clarity || "—") +
      "</td>" +
      "<td>" +
      escapeHtml(formatCutLabel(item.cut)) +
      "</td>" +
      "<td>" +
      escapeHtml(formatTableLab(item.lab)) +
      "</td>" +
      "<td>" +
      '<span class="ring-builder-diamonds__table-price-current">' +
      escapeHtml(formatTablePrice(item.price)) +
      "</span>" +
      formatTableCompareAt(item.price) +
      "</td>" +
      "</tr>"
    );
  }

  function formatTableCompareAt(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.formatCompareAtMoneyRounded === "function"
    ) {
      var text = window.RingBuilderDiamondMargin.formatCompareAtMoneyRounded(price);
      if (text) {
        return (
          ' <s class="ring-builder-diamonds__table-price-compare">' +
          escapeHtml(text) +
          "</s>"
        );
      }
    }
    return "";
  }

  function appendTableRow(tbody, item) {
    if (!tbody) return;
    tbody.insertAdjacentHTML("beforeend", renderTableRow(item));
    bindTableRowImageFallback(tbody.lastElementChild, item);
  }

  function appendGridCard(grid, item) {
    if (!grid) return;
    var node = createUbCardNode(item);
    if (node) grid.appendChild(node);
  }

  var PROMO_FIRST_AFTER_PRODUCTS = 8;
  var PROMO_SUBSEQUENT_GAP = 8;
  var PROMO_ANCHOR = 8;
  var PROMO_THRESHOLD = 16;

  function isDiamondGridPromosEnabled() {
    var root = getRoot();
    return !!(root && root.getAttribute("data-diamond-grid-promos-enabled") === "true");
  }

  function getPromoNumberForSlot(productsBefore, gridPosition) {
    if (productsBefore === PROMO_FIRST_AFTER_PRODUCTS) return 1;
    if (gridPosition >= PROMO_THRESHOLD) {
      var gridBeforePromo = gridPosition - PROMO_ANCHOR;
      if (gridBeforePromo % PROMO_SUBSEQUENT_GAP === 0) {
        var promoNum = Math.floor(gridBeforePromo / PROMO_SUBSEQUENT_GAP) + 1;
        if (promoNum <= 10) return promoNum;
      }
    }
    return 0;
  }

  function clonePromoNode(promoNum) {
    var root = getRoot();
    if (!root) return null;
    var template = root.querySelector(
      '[data-diamond-grid-promo-template="' + promoNum + '"]',
    );
    if (!template || !template.content) return null;
    var node = template.content.firstElementChild;
    if (!node) return null;
    return node.cloneNode(true);
  }

  function appendPromoIfNeeded(grid, productsBefore, gridPosition) {
    if (!isDiamondGridPromosEnabled() || !grid) return gridPosition;

    var promoNum = getPromoNumberForSlot(productsBefore, gridPosition);
    if (!promoNum) return gridPosition;

    var promoNode = clonePromoNode(promoNum);
    if (!promoNode) return gridPosition;

    grid.appendChild(promoNode);
    return gridPosition + 1;
  }

  function hasDiamondImage(item) {
    return !!(item && item.image && String(item.image).trim());
  }

  function sortDiamondsByImage(items) {
    // Keep Nivoda API order (price/carat sort). Do not re-rank by image — that
    // made cheap stones without photos sink below more expensive imaged stones.
    return Array.isArray(items) ? items.slice() : [];
  }

  function dedupeDiamondsByOfferId(items) {
    var seen = {};
    var unique = [];

    items.forEach(function (item) {
      var id = item && item.offerId;
      if (!id || seen[id]) return;
      seen[id] = true;
      unique.push(item);
    });

    return unique;
  }

  function appendItem(item, index, gridPosition) {
    appendTableRow(getTableBody(), item);
    var grid = getGrid();
    var nextGridPosition = appendPromoIfNeeded(grid, index, gridPosition);
    appendGridCard(grid, item);
    return nextGridPosition + 1;
  }

  function renderAllItems() {
    var tbody = getTableBody();
    var grid = getGrid();
    if (tbody) tbody.innerHTML = "";
    if (grid) grid.innerHTML = "";

    var gridPosition = 0;
    state.items.forEach(function (item, index) {
      gridPosition = appendItem(item, index, gridPosition);
    });

    restoreSelectedCard();
  }

  function updateResultMeta() {
    var root = getRoot();
    if (!root) return;

    var meta = root.querySelector("[data-diamond-result-meta]");
    var loadMoreWrap = root.querySelector("[data-diamond-load-more-wrap]");

    if (meta) {
      var shownCount = state.items.length;
      var displayTotal = getDisplayTotalCount(shownCount);
      var shownEl = meta.querySelector("[data-diamond-result-shown]");
      var totalEl = meta.querySelector("[data-diamond-result-total]");
      var totalWrap = meta.querySelector("[data-diamond-result-total-wrap]");

      if (shownCount > 0) {
        if (shownEl) {
          shownEl.textContent = formatDiamondCount(shownCount);
        } else {
          meta.textContent =
            "Showing " +
            formatDiamondCount(shownCount) +
            (displayTotal > shownCount
              ? " of " + formatDiamondCount(displayTotal) + " diamonds"
              : " diamonds");
        }

        if (totalEl && displayTotal > 0) {
          totalEl.textContent = formatDiamondCount(displayTotal);
        }
        if (totalWrap) {
          totalWrap.hidden = !(displayTotal > shownCount);
        }
        meta.hidden = false;
      } else {
        if (shownEl) shownEl.textContent = "0";
        if (totalEl) totalEl.textContent = "0";
        if (totalWrap) totalWrap.hidden = true;
        meta.hidden = true;
      }
    }

    if (loadMoreWrap) {
      setLoadMoreVisibility();
    }
  }

  function markSelectedCard(offerId) {
    var root = getRoot();
    if (!root) return;

    root.querySelectorAll("[data-diamond-card]").forEach(function (card) {
      card.classList.toggle(
        "is-selected",
        card.getAttribute("data-offer-id") === offerId,
      );
    });
  }

  function restoreSelectedCard() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved && saved.offerId) markSelectedCard(saved.offerId);
    } catch (e) {}
  }

  function loadDiamonds(append) {
    var root = getRoot();
    if (!root) return Promise.resolve();

    if (state.loading) {
      if (!append) {
        state.pendingReload = true;
        syncUrlFromUi();
      }
      return Promise.resolve();
    }

    var filters = getFilters();
    var requestId = ++state.requestId;

    if (!append) {
      syncFiltersToUrl(filters);
      state.apiOffset = 0;
      state.lastPageRawCount = 0;
      state.totalCount = 0;
      state.priceRangeComplete = false;
      state.priceSkipPages = 0;
      state.items = [];
      var tbody = getTableBody();
      var grid = getGrid();
      if (tbody) tbody.innerHTML = "";
      if (grid) grid.innerHTML = "";
      setPanelMessage("");
    }

    setLoading(true, append);

    var fetchLimit = getFetchLimit(append);

    persistFilters(filters);
    return fetch(buildProxyUrl(filters, state.apiOffset, fetchLimit))
      .then(function (res) {
        return parseProxyJsonResponse(res);
      })
      .then(function (data) {
        if (requestId !== state.requestId) return;
        if (data.error) throw new Error(data.error);

        var pageItems = data.items || [];
        var apiTotal = Number(data.total_count || 0);
        var rawItems = pageItems;
        var isCertLookup = !!(filters.cert_number && String(filters.cert_number).trim());

        // Extra safety: when White colour mode is active, drop Fancy stones
        // even if the proxy returned mixed results. Skip for report-number
        // lookup so a matching cert is never hidden by colour-mode filtering.
        if (
          !isCertLookup &&
          filters.colour_mode !== "fancy" &&
          filters.diamond_type !== "labgrown_colour"
        ) {
          rawItems = pageItems.filter(function (item) {
            var color = String((item && item.color) || "").trim().toUpperCase();
            return color && color !== "FANCY" && color.indexOf("FANCY") === -1;
          });
        }

        var priceBounds = isCertLookup ? null : getRequestedPriceBounds(filters);
        state.clientPriceFilter = !!priceBounds;
        if (priceBounds) {
          rawItems = rawItems.filter(function (item) {
            return itemWithinPriceBounds(item, priceBounds);
          });
          var sortKey = normalizeDiamondSort(filters.sort);
          var priced = [];
          pageItems.forEach(function (item) {
            var dollars = getRetailDollars(item);
            if (isFinite(dollars) && dollars > 0) priced.push(dollars);
          });
          var lowest = priced.length ? Math.min.apply(null, priced) : NaN;
          var highest = priced.length ? Math.max.apply(null, priced) : NaN;
          if (!pageItems.length) {
            state.priceRangeComplete = true;
          } else if (sortKey === "price_asc" && isFinite(highest) && highest > priceBounds.max) {
            state.priceRangeComplete = true;
          } else if (sortKey === "price_desc" && isFinite(lowest) && lowest < priceBounds.min) {
            state.priceRangeComplete = true;
          } else if (sortKey !== "price_asc" && sortKey !== "price_desc") {
            state.priceRangeComplete = false;
          }
        } else {
          state.priceRangeComplete = false;
        }

        if (!append) {
          state.totalCount = apiTotal;
        } else if (apiTotal > state.totalCount) {
          state.totalCount = apiTotal;
        }

        // The proxy can remove rows after Nivoda has applied its offset (for
        // example, its price-range safety filter). Advancing by pageItems.length
        // would overlap the previous API page and Load More would appear to do
        // nothing after duplicate offers are removed. Advance by the requested
        // page size unless the proxy provides an explicit cursor.
        var rawPageCount = Number(data.raw_count);
        state.lastPageRawCount = isFinite(rawPageCount)
          ? rawPageCount
          : pageItems.length;
        state.lastFetchLimit = fetchLimit;
        var nextOffset = Number(data.next_offset);
        if (isFinite(nextOffset) && nextOffset > state.apiOffset) {
          state.apiOffset = nextOffset;
        } else if (pageItems.length || state.apiOffset < state.totalCount) {
          state.apiOffset += fetchLimit;
        }
        state.items = sortDiamondsByImage(
          dedupeDiamondsByOfferId(
            append ? state.items.concat(rawItems) : rawItems,
          ),
        );

        if (!rawItems.length && !append) {
          setPanelMessage(
            "No diamonds match these filters. Try widening carat or clarity.",
            false,
          );
        } else if (!append) {
          setPanelMessage("");
        }

        renderAllItems();
        updateResultMeta();
        restoreSelectedCard();
        if (!append) maybeOpenSharedDiamond(rawItems);

        if (
          priceBounds &&
          !rawItems.length &&
          !state.priceRangeComplete &&
          hasMoreDiamondsToLoad() &&
          state.priceSkipPages < 8
        ) {
          state.priceSkipPages += 1;
          state.continuePriceScan = true;
        }
      })
      .catch(function (err) {
        if (requestId !== state.requestId) return;
        var message =
          (err && err.message) ||
          "Unable to load diamonds. Check that your Nivoda proxy is running and the proxy URL is correct in theme settings.";
        if (/failed to fetch|networkerror|load failed/i.test(String(message))) {
          message = isDesignMode()
            ? "Diamonds load on the live storefront. Use Preview (top right) to test the diamond collection."
            : "Unable to reach the diamond service. Please refresh and try again.";
        }
        setPanelMessage(message, true);
      })
      .finally(function () {
        if (requestId !== state.requestId) return;
        setLoading(false);
        if (state.continuePriceScan) {
          state.continuePriceScan = false;
          loadDiamonds(true);
          return;
        }
        if (state.pendingReload) {
          state.pendingReload = false;
          loadDiamonds(false);
        }
      });
  }

  function saveDiamond(item) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(item));
    } catch (e) {}
  }

  function getSavedDiamond() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function updateSearchTitle() {
    var root = getRoot();
    if (!root) return;
    var titleEl =
      root.querySelector("[data-diamond-filters-title]") ||
      root.querySelector(".ring-builder-diamonds__filters-title") ||
      document.querySelector(".pc-search-for-diamondtype");
    if (!titleEl) return;

    var filters = getFilters();
    var shapeName = filters.shape ? getShapeDisplayLabel(filters.shape) : "";
    var shapeLabel = shapeName ? shapeName + " " : "";
    var typeLabel = "Natural";
    if (filters.diamond_type === "labgrown_colour") {
      typeLabel = "Lab Grown Colour";
    } else if (filters.diamond_type === "labgrown") {
      typeLabel = "Lab Grown";
    }
    titleEl.textContent = "Search For " + shapeLabel + typeLabel + " Diamond";
  }

  function initSliders() {
    var root = getRoot();
    if (!root || typeof noUiSlider === "undefined") return;

    // 1. Carat Slider — floor 0.01 so AUD $1–$50 small stones (0.15ct+) match Nivoda
    var caratSlider = root.querySelector('#carat-slider');
    if (caratSlider && !caratSlider.noUiSlider) {
      var caratDefaults = getFilterDefaults();
      var minValInput = root.querySelector('[data-diamond-filter="carat_min"]');
      var maxValInput = root.querySelector('[data-diamond-filter="carat_max"]');
      var startMin = minValInput ? parseFloat(minValInput.value) : caratDefaults.caratMin;
      var startMax = maxValInput ? parseFloat(maxValInput.value) : caratDefaults.caratMax;
      if (!isFinite(startMin)) startMin = caratDefaults.caratMin;
      if (!isFinite(startMax)) startMax = caratDefaults.caratMax;
      var caratFloor = 0.01;
      if (startMin < caratFloor) startMin = caratFloor;

      noUiSlider.create(caratSlider, {
        start: [startMin, startMax],
        connect: true,
        step: 0.01,
        range: {
          'min': caratFloor,
          'max': caratDefaults.caratMax
        }
      });

      var label = root.querySelector('#carat-value-label');
      caratSlider.noUiSlider.on('update', function (values) {
        var min = parseFloat(values[0]).toFixed(2);
        var max = parseFloat(values[1]).toFixed(2);
        if (minValInput) minValInput.value = min;
        if (maxValInput) maxValInput.value = max;
        if (label) label.textContent = min + 'ct – ' + max + 'ct';
        root.querySelectorAll('[data-diamond-range="carat_min"]').forEach(function (el) {
          if (el !== minValInput) el.value = min;
        });
        root.querySelectorAll('[data-diamond-range="carat_max"]').forEach(function (el) {
          if (el !== maxValInput) el.value = max;
        });
      });

      caratSlider.noUiSlider.on('change', function () {
        scheduleFilterReload();
      });
    }

    // Price Slider — range floor is absolute (0), start uses section default.
    var priceSlider = root.querySelector('#price-slider');
    if (priceSlider && !priceSlider.noUiSlider) {
      var priceDefaults = getFilterDefaults();
      var priceMinInput = root.querySelector('[data-diamond-filter="price_min"]');
      var priceMaxInput = root.querySelector('[data-diamond-filter="price_max"]');
      var startMin = priceMinInput ? parseFloat(priceMinInput.value) : priceDefaults.priceMin;
      var startMax = priceMaxInput ? parseFloat(priceMaxInput.value) : priceDefaults.priceMax;
      if (!isFinite(startMin)) startMin = priceDefaults.priceMin;
      if (!isFinite(startMax)) startMax = priceDefaults.priceMax;
      if (startMin < priceDefaults.priceFloor) startMin = priceDefaults.priceFloor;

      noUiSlider.create(priceSlider, {
        start: [startMin, startMax],
        connect: true,
        step: 1,
        range: {
          'min': priceDefaults.priceFloor,
          'max': priceDefaults.priceMax
        }
      });

      var label = root.querySelector('#price-value-label');
      priceSlider.noUiSlider.on('update', function (values) {
        var min = Math.round(values[0]);
        var max = Math.round(values[1]);
        if (priceMinInput) priceMinInput.value = min;
        if (priceMaxInput) priceMaxInput.value = max;
        if (label) label.textContent = '$' + min.toLocaleString() + ' – $' + max.toLocaleString();
        root.querySelectorAll('[data-diamond-range="price_min"]').forEach(function (el) {
          el.value = min;
        });
        root.querySelectorAll('[data-diamond-range="price_max"]').forEach(function (el) {
          el.value = max;
        });
      });

      priceSlider.noUiSlider.on('change', function () {
        scheduleFilterReload();
      });
    }

    function bindNumericRangeSlider(sliderId, minKey, maxKey, rangeMin, rangeMax, step, decimals) {
      var sliderEl = root.querySelector(sliderId);
      if (!sliderEl || sliderEl.noUiSlider) return;

      var minInput = root.querySelector('[data-diamond-filter="' + minKey + '"]');
      var maxInput = root.querySelector('[data-diamond-filter="' + maxKey + '"]');

      noUiSlider.create(sliderEl, {
        start: [rangeMin, rangeMax],
        connect: true,
        step: step,
        range: { min: rangeMin, max: rangeMax }
      });

      sliderEl.noUiSlider.on('update', function (values) {
        var minN = parseFloat(values[0]);
        var maxN = parseFloat(values[1]);
        var min = decimals ? minN.toFixed(decimals) : String(Math.round(minN));
        var max = decimals ? maxN.toFixed(decimals) : String(Math.round(maxN));
        var isFull =
          Math.abs(minN - rangeMin) < step * 0.5 &&
          Math.abs(maxN - rangeMax) < step * 0.5;

        if (minInput) minInput.value = isFull ? "" : min;
        if (maxInput) maxInput.value = isFull ? "" : max;
        root.querySelectorAll('[data-diamond-range="' + minKey + '"]').forEach(function (el) {
          el.value = min;
        });
        root.querySelectorAll('[data-diamond-range="' + maxKey + '"]').forEach(function (el) {
          el.value = max;
        });
      });

      sliderEl.noUiSlider.on('change', function () {
        scheduleFilterReload();
      });
    }

    bindNumericRangeSlider('#table-slider', 'table_min', 'table_max', 30, 90, 1, 0);
    bindNumericRangeSlider('#depth-slider', 'depth_min', 'depth_max', 30, 90, 0.1, 1);
    bindNumericRangeSlider('#ratio-slider', 'ratio_min', 'ratio_max', 0.8, 2.5, 0.1, 1);
  }

  function selectAndProceedDiamond(item) {
    saveDiamond(item);
    markSelectedCard(item.offerId);

    if (!hasSelectedSetting()) {
      localStorage.setItem(FLOW_KEY, FLOW_DIAMOND_FIRST);
      if (
        window.RingBuilderFlow &&
        typeof window.RingBuilderFlow.setPresentation === "function"
      ) {
        window.RingBuilderFlow.setPresentation(FLOW_DIAMOND_FIRST);
      }
    }

    var nextStep = getNextStepAfterDiamondSelection();
    localStorage.setItem("ringBuilderCurrentStep", nextStep);

    var detailView = document.getElementById("DiamondDetailView");
    if (detailView) {
      showDiamondSearchLayout();
    }

    document.dispatchEvent(
      new CustomEvent("ring-builder:diamond-selected", {
        bubbles: true,
        detail: {
          nextStep: nextStep,
          item: item,
        },
      }),
    );

    if (window.location.pathname.indexOf("/collections/ring-builder") === -1) {
      window.location.href = buildRingBuilderUrl(nextStep);
    }
  }

  function getDiamondDetailPdpConfig() {
    var el = document.getElementById("DiamondDetailPdpConfig");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function formatDeliveryRange(minDays, maxDays) {
    var min = Number(minDays) || 30;
    var max = Number(maxDays) || 35;
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    start.setDate(start.getDate() + min);
    end.setDate(end.getDate() + max);
    var fmt = function (date) {
      return date.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
    };
    return fmt(start) + " – " + fmt(end);
  }

  function formatCaratDisplay(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "—";
    if (value % 1 === 0) return value.toFixed(1);
    return value.toFixed(2).replace(/\.?0+$/, "");
  }

  function formatLengthWidth(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    if (!isFinite(length) || !isFinite(width)) return "—";
    return length.toFixed(2) + " \u00d7 " + width.toFixed(2);
  }

  function formatDiamondRatio(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    if (!isFinite(length) || !isFinite(width) || width <= 0) return "—";
    return (length / width).toFixed(2);
  }

  function getDiamondKeySpecValues(item) {
    var cutLabel = formatCutLabel(item.cut);
    var dims = formatLengthWidth(item);
    return {
      carat: formatCaratDisplay(item.carats),
      color: item.color || "—",
      clarity: item.clarity || "—",
      cut: cutLabel || "—",
      ratio: formatDiamondRatio(item),
      measurements: dims,
    };
  }

  function populateDiamondSpecGrid(container, item) {
    if (!container) return;
    var values = getDiamondKeySpecValues(item);
    Object.keys(values).forEach(function (key) {
      var el = container.querySelector('[data-detail-spec="' + key + '"]');
      if (!el) return;
      el.textContent = values[key];
      if (key === "measurements" && values[key] !== "—") {
        el.title = values[key];
      } else {
        el.removeAttribute("title");
      }
    });
  }

  function buildDetailSpecsTableHtml(specs) {
    var html = "";
    specs.forEach(function (spec) {
      html +=
        "<tr><td>" +
        escapeHtml(spec.label) +
        "</td><td>" +
        escapeHtml(spec.value || "—") +
        "</td></tr>";
    });
    return html;
  }

  function buildDetailDescriptionHtml(item) {
    var intro =
      '<p class="diamond-detail-specs-panel__intro">This ' +
      escapeHtml(formatCaratsTitle(item.carats)) +
      " " +
      escapeHtml(formatShapeLabel(item.shape)) +
      " diamond is independently certified" +
      (item.lab ? " by " + escapeHtml(item.lab) : "") +
      (item.certNumber ? " (report #" + escapeHtml(item.certNumber) + ")" : "") +
      ".</p>";

    var specsLeft = [
      { label: "Shape", value: formatShapeLabel(item.shape) },
      { label: "Carat Weight", value: formatCarats(item.carats) },
      { label: "Color", value: item.color || "—" },
      { label: "Clarity", value: item.clarity || "—" },
      { label: "Cut Grade", value: formatCutLabel(item.cut) },
      { label: "Lab", value: item.lab || "—" },
    ];

    var specsRight = [
      { label: "Certificate Number", value: item.certNumber || "—" },
      { label: "Dimensions", value: formatDimensions(item) || "—" },
      { label: "Polish", value: item.polish || "—" },
      { label: "Symmetry", value: item.symmetry || "—" },
      { label: "Fluorescence", value: item.fluorescence || "—" },
      { label: "Origin", value: item.labgrown ? "Lab Grown" : "Natural" },
    ];

    return (
      '<div class="diamond-detail-specs-panel">' +
      intro +
      '<div class="rb-complete-specs-grid">' +
      '<div class="diamond-detail-specs-panel__col"><table class="diamond-detail-specs-table"><tbody>' +
      buildDetailSpecsTableHtml(specsLeft) +
      "</tbody></table></div>" +
      '<div class="diamond-detail-specs-panel__col"><table class="diamond-detail-specs-table"><tbody>' +
      buildDetailSpecsTableHtml(specsRight) +
      "</tbody></table></div>" +
      "</div></div>"
    );
  }

  function updateDiamondWhatsAppLink(detailView, item, title) {
    var link = (detailView || document).querySelector("[data-diamond-whatsapp-link]");
    if (!link) return;

    var phone = String(link.getAttribute("data-wa-phone") || "61406676660").replace(/\D/g, "");
    var baseMessage = String(link.getAttribute("data-wa-message") || "Hi Diamonds For Everyone, I would like to customise a ring with this diamond.").trim();
    var sku = String((item && (item.certNumber || item.offerId)) || "").trim();
    var shareId = getDiamondShareId(item);
    var shareUrl = shareId ? buildDiamondShareUrl(shareId) : window.location.href;
    var parts = [baseMessage];
    if (title) parts.push(title);
    if (sku) parts.push("SKU: " + sku);
    if (shareUrl) parts.push(shareUrl);
    link.href = "https://wa.me/" + phone + "?text=" + encodeURIComponent(parts.join("\n"));
  }

  function populateDiamondDetailPdp(item) {
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return;

    var config = getDiamondDetailPdpConfig();
    var deliveryEl = detailView.querySelector("[data-detail-delivery-range]");
    if (deliveryEl) {
      deliveryEl.textContent = formatDeliveryRange(
        config.deliveryMinDays,
        config.deliveryMaxDays,
      );
    }

    populateDiamondSpecGrid(
      detailView.querySelector("[data-detail-product-specs]"),
      item,
    );

    var descriptionEl = detailView.querySelector("[data-detail-description]");
    if (descriptionEl) {
      descriptionEl.innerHTML = buildDetailDescriptionHtml(item);
    }

    var shippingContentEl = detailView.querySelector("[data-detail-shipping-content]");
    if (shippingContentEl && config.shippingContent && !shippingContentEl.innerHTML.trim()) {
      shippingContentEl.innerHTML = config.shippingContent;
    }
  }

  var alternativesAbortController = null;
  var alternativesClickBound = false;

  var COLOR_RANK = { D: 0, E: 1, F: 2, G: 3, H: 4, I: 5, J: 6, K: 7, L: 8, M: 9, N: 10 };
  var CLARITY_RANK = {
    FL: 0, IF: 1, VVS1: 2, VVS2: 3, VS1: 4, VS2: 5, SI1: 6, SI2: 7, I1: 8, I2: 9, I3: 10,
  };

  function normalizeGradeKey(value) {
    return String(value || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function getColorRank(color) {
    var key = normalizeGradeKey(color);
    return Object.prototype.hasOwnProperty.call(COLOR_RANK, key) ? COLOR_RANK[key] : 99;
  }

  function getClarityRank(clarity) {
    var key = normalizeGradeKey(clarity);
    return Object.prototype.hasOwnProperty.call(CLARITY_RANK, key) ? CLARITY_RANK[key] : 99;
  }

  function expandGradeRange(value, ranks) {
    var key = normalizeGradeKey(value);
    var list = Object.keys(ranks);
    var idx = list.indexOf(key);
    if (idx < 0) return key || "";
    var start = Math.max(0, idx - 1);
    var end = Math.min(list.length - 1, idx + 1);
    return list.slice(start, end + 1).join(",");
  }

  function getWholesalePrice(item) {
    var value = Number(item && item.price);
    return isFinite(value) ? value : Number.POSITIVE_INFINITY;
  }

  function getQualityScore(item) {
    return getColorRank(item.color) * 10 + getClarityRank(item.clarity);
  }

  function buildAlternativesFilters(item) {
    var carats = Number(item.carats);
    if (!isFinite(carats) || carats <= 0) carats = 1;

    var caratMin = Math.max(0.01, Number((carats * 0.9).toFixed(2)));
    var caratMax = Number((carats * 1.1).toFixed(2));
    var color = normalizeGradeKey(item.color);
    var isFancy = !color || color === "FANCY";

    return {
      shape: item.shape || "",
      carat_min: String(caratMin),
      carat_max: String(caratMax),
      diamond_type: isLabDiamond(item) ? "labgrown" : "natural",
      colour_mode: isFancy ? "fancy" : "white",
      color: isFancy ? "" : expandGradeRange(item.color, COLOR_RANK),
      clarity: expandGradeRange(item.clarity, CLARITY_RANK),
      sort: "price_asc",
    };
  }

  function getMatchScore(currentItem, candidate) {
    var shapeMatch =
      normalizeShapeKey(currentItem.shape) === normalizeShapeKey(candidate.shape) ? 0 : 50;
    var caratDiff = Math.abs(Number(currentItem.carats) - Number(candidate.carats));
    var colorDiff = Math.abs(getColorRank(currentItem.color) - getColorRank(candidate.color));
    var clarityDiff = Math.abs(getClarityRank(currentItem.clarity) - getClarityRank(candidate.clarity));
    return shapeMatch + caratDiff * 20 + colorDiff * 8 + clarityDiff * 6;
  }

  function pickBestAlternatives(currentItem, items) {
    var currentId = String((currentItem && currentItem.offerId) || "");
    var pool = (items || [])
      .filter(function (candidate) {
        return candidate && candidate.offerId && String(candidate.offerId) !== currentId;
      })
      .sort(function (a, b) {
        return getMatchScore(currentItem, a) - getMatchScore(currentItem, b);
      });

    if (!pool.length) return [];

    var byPrice = pool.slice().sort(function (a, b) {
      return getWholesalePrice(a) - getWholesalePrice(b);
    });
    var bestPrice = byPrice[0];

    var byUpgrade = pool
      .filter(function (candidate) {
        return getQualityScore(candidate) < getQualityScore(currentItem);
      })
      .sort(function (a, b) {
        var qualityDiff = getQualityScore(a) - getQualityScore(b);
        if (qualityDiff !== 0) return qualityDiff;
        return getMatchScore(currentItem, a) - getMatchScore(currentItem, b);
      });
    var bestUpgrade = byUpgrade[0] || pool[0];

    var byValue = pool.slice().sort(function (a, b) {
      var valueA = getWholesalePrice(a) / Math.max(0.01, Number(a.carats) || 0.01);
      var valueB = getWholesalePrice(b) / Math.max(0.01, Number(b.carats) || 0.01);
      var scoreA = valueA * (1 + getQualityScore(a) * 0.02);
      var scoreB = valueB * (1 + getQualityScore(b) * 0.02);
      return scoreA - scoreB;
    });
    var bestValue = byValue[0];

    var selected = [];
    var used = {};

    function pushLabeled(label, candidate) {
      if (!candidate || !candidate.offerId) return;
      var id = String(candidate.offerId);
      if (used[id]) return;
      used[id] = true;
      selected.push({ label: label, item: candidate });
    }

    pushLabeled("Best Value", bestValue);
    pushLabeled("Best Price", bestPrice);
    pushLabeled("Best Upgrade", bestUpgrade);

    pool.forEach(function (candidate) {
      if (selected.length >= 3) return;
      pushLabeled("Best Match", candidate);
    });

    return selected.slice(0, 3);
  }

  function setAlternativesStatus(message) {
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return;
    var statusEl = detailView.querySelector("[data-diamond-alternatives-status]");
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = "";
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function renderAlternativeCard(entry) {
    var node = createUbCardNode(entry.item);
    if (!node) return null;

    node.classList.add("diamond-alternatives__item");
    node.setAttribute("data-diamond-alternative-card", "true");

    // Prefer Best Value / Best Price / Best Upgrade over selling badge
    if (entry.label) {
      setFieldText(node, "selling-badge", entry.label);
      setFieldVisibility(node, "selling-badge", true);
    }

    // Use 3-up columns for alternatives (same card design as browse)
    node.classList.remove("col-lg-3");
    if (!node.classList.contains("col-lg-4")) {
      node.classList.add("col-lg-4");
    }

    return node;
  }

  function bindDiamondAlternativesClicks() {
    if (alternativesClickBound) return;
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return;
    alternativesClickBound = true;
    detailView.addEventListener("click", function (event) {
      var card = event.target.closest("[data-diamond-alternative-card]");
      if (!card || !detailView.contains(card)) return;
      event.preventDefault();
      event.stopPropagation();

      var selectBtn = card.querySelector("[data-diamond-select]");
      var payload = selectBtn
        ? selectBtn.getAttribute("data-diamond-payload")
        : null;
      if (!payload) return;
      try {
        openDiamondPreview(JSON.parse(payload));
        window.scrollTo({ top: Math.max(0, detailView.offsetTop - 80), behavior: "smooth" });
      } catch (e) {}
    });
  }

  function loadDiamondAlternatives(item) {
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView || !item) return;

    var section = detailView.querySelector("[data-diamond-alternatives]");
    var grid = detailView.querySelector("[data-diamond-alternatives-grid]");
    if (!section || !grid) return;

    bindDiamondAlternativesClicks();

    if (alternativesAbortController) {
      alternativesAbortController.abort();
    }
    alternativesAbortController = typeof AbortController !== "undefined" ? new AbortController() : null;

    section.hidden = false;
    grid.innerHTML = "";
    setAlternativesStatus("Finding similar diamonds…");

    var filters = buildAlternativesFilters(item);
    var url = buildProxyUrl(filters, 0, 24);
    var fetchOptions = alternativesAbortController
      ? { signal: alternativesAbortController.signal }
      : {};

    fetch(url, fetchOptions)
      .then(function (response) {
        if (!response.ok) throw new Error("Alternatives request failed");
        return response.json();
      })
      .then(function (data) {
        var picks = pickBestAlternatives(item, (data && data.items) || []);
        if (!picks.length) {
          section.hidden = true;
          grid.innerHTML = "";
          setAlternativesStatus("");
          return;
        }
        setAlternativesStatus("");
        var fragment = document.createDocumentFragment();
        picks.forEach(function (entry) {
          var node = renderAlternativeCard(entry);
          if (node) fragment.appendChild(node);
        });
        grid.appendChild(fragment);
        section.hidden = false;
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return;
        section.hidden = true;
        grid.innerHTML = "";
        setAlternativesStatus("");
      });
  }

  function openDiamondPreview(item) {
    persistFilters(getFilters());
    var detailView = document.getElementById("DiamondDetailView");
    if (!detailView) return;

    state.currentDiamond = item;
    setOpenDiamondUrl(getDiamondShareId(item));

    var title = formatCaratsTitle(item.carats) + " " + formatShapeLabel(item.shape) + " Diamond";
    
    // Title
    var titleEl = detailView.querySelector("#DiamondDetailTitle");
    if (titleEl) titleEl.textContent = title;

    // Price
    var priceEl = detailView.querySelector("[data-detail-price]");
    if (priceEl) priceEl.textContent = formatPrice(item.price);

    var compareAtEl = detailView.querySelector("[data-detail-price-compare]");
    var compareAtText = formatCompareAtPrice(item.price);
    if (compareAtEl) {
      compareAtEl.textContent = compareAtText;
      compareAtEl.hidden = !compareAtText;
    }

    updateDiamondPaymentOffers(detailView, item);

    // Cert lab badge link
    populateDetailLabBadgeLink(detailView, item);

    // Lab / Natural badge on media view
    populateDetailOriginBadge(detailView, item);

    // SKU uses certificate number when available
    var skuEl = detailView.querySelector("[data-detail-sku]");
    if (skuEl) {
      var skuValue = item.certNumber || item.offerId || "—";
      skuEl.textContent = "SKU: " + skuValue;
    }

    populateDiamondDetailPdp(item);
    updateDiamondWhatsAppLink(detailView, item, title);

    // Media — default to 360° video when available
    var mediaContainer = detailView.querySelector("[data-detail-video-container]");
    var activeMediaMode = item.video ? "video" : item.image ? "image" : "none";

    function refreshDetailMedia() {
      if (!mediaContainer) return;

      var embed = getDiamondMediaEmbedSize(mediaContainer);
      if (embed.width < 50 || embed.height < 50) return;

      var mediaUrl =
        activeMediaMode === "video"
          ? item.video
          : activeMediaMode === "image"
            ? item.image
            : "";

      if (mediaUrl) {
        renderDetailMediaContent(
          mediaContainer,
          mediaUrl,
          title,
          embed.width,
          embed.height,
          activeMediaMode,
          item
        );
        return;
      }

      renderDetailShapeFallback(mediaContainer, item, title);
    }

    function scheduleDetailMediaRender() {
      [0, 50, 150, 400, 800].forEach(function (delay) {
        window.setTimeout(function () {
          requestAnimationFrame(refreshDetailMedia);
        }, delay);
      });
    }

    function bindDetailMediaResize() {
      if (!mediaContainer || typeof ResizeObserver === "undefined") return;
      var mediaMain = mediaContainer.closest(".diamond-detail-view__media-main");
      if (!mediaMain) return;

      if (mediaMain._diamondMediaResizeObserver) {
        mediaMain._diamondMediaResizeObserver.disconnect();
      }

      var resizeTimer = null;
      mediaMain._diamondMediaResizeObserver = new ResizeObserver(function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(refreshDetailMedia, 100);
      });
      mediaMain._diamondMediaResizeObserver.observe(mediaMain);
    }

    function showVideo() {
      if (!mediaContainer || !item.video) return;
      activeMediaMode = "video";
      scheduleDetailMediaRender();
    }

    function showImage() {
      if (!mediaContainer || !item.image) return;
      activeMediaMode = "image";
      scheduleDetailMediaRender();
    }

    if (!item.video && !item.image && mediaContainer) {
      renderDetailShapeFallback(mediaContainer, item, title);
    }

    // Media Thumbs
    var mediaThumbs = detailView.querySelector("[data-detail-media-thumbs]");
    if (mediaThumbs) {
      mediaThumbs.innerHTML = "";
      if (item.video && item.image) {
        var videoBtn = document.createElement("button");
        videoBtn.type = "button";
        videoBtn.className = "is-active";
        videoBtn.textContent = "360° Video";

        var imageBtn = document.createElement("button");
        imageBtn.type = "button";
        imageBtn.textContent = "Diamond Image";

        videoBtn.addEventListener("click", function(e) {
          e.preventDefault();
          videoBtn.classList.add("is-active");
          imageBtn.classList.remove("is-active");
          showVideo();
        });

        imageBtn.addEventListener("click", function(e) {
          e.preventDefault();
          imageBtn.classList.add("is-active");
          videoBtn.classList.remove("is-active");
          showImage();
        });

        mediaThumbs.appendChild(videoBtn);
        mediaThumbs.appendChild(imageBtn);
      } else if (item.video) {
        var videoOnlyBtn = document.createElement("button");
        videoOnlyBtn.type = "button";
        videoOnlyBtn.className = "is-active";
        videoOnlyBtn.textContent = "360° Video";
        videoOnlyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          showVideo();
        });
        mediaThumbs.appendChild(videoOnlyBtn);
      } else if (item.image) {
        var imageOnlyBtn = document.createElement("button");
        imageOnlyBtn.type = "button";
        imageOnlyBtn.className = "is-active";
        imageOnlyBtn.textContent = "Diamond Image";
        imageOnlyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          showImage();
        });
        mediaThumbs.appendChild(imageOnlyBtn);
      }

      appendCertificateThumbButton(mediaThumbs, item);
    }

    // Bind primary CTA (Add to cart on standalone page, add to setting on ring builder)
    var chooseBtn = detailView.querySelector("[data-detail-choose-btn]");
    if (chooseBtn) {
      var newChooseBtn = chooseBtn.cloneNode(true);
      chooseBtn.parentNode.replaceChild(newChooseBtn, chooseBtn);
      if (isStandaloneDiamondBrowse()) {
        var addToCartLabel = (newChooseBtn.textContent || "Add to cart").trim() || "Add to cart";
        newChooseBtn.textContent = addToCartLabel;
        newChooseBtn.addEventListener("click", function (e) {
          e.preventDefault();
          newChooseBtn.disabled = true;
          newChooseBtn.textContent = "Adding…";
          addDiamondLineToCart(item, "", newChooseBtn, addToCartLabel);
        });
      } else {
        newChooseBtn.addEventListener("click", function (e) {
          e.preventDefault();
          selectAndProceedDiamond(item);
        });
      }
    }

    // Purchase loose diamond (ring builder only)
    if (!isStandaloneDiamondBrowse()) {
      var buyLooseBtn = detailView.querySelector("[data-detail-buy-loose-btn]");
      if (buyLooseBtn) {
        var newBuyLooseBtn = buyLooseBtn.cloneNode(true);
        buyLooseBtn.parentNode.replaceChild(newBuyLooseBtn, buyLooseBtn);
        var looseLabel =
          (newBuyLooseBtn.textContent || "Purchase Loose Diamond").trim() ||
          "Purchase Loose Diamond";
        newBuyLooseBtn.addEventListener("click", function (e) {
          e.preventDefault();
          newBuyLooseBtn.disabled = true;
          newBuyLooseBtn.textContent = "Adding…";
          addDiamondLineToCart(item, "", newBuyLooseBtn, looseLabel);
        });
      }
    }

    // Bind Back to search button
    var backBtn = detailView.querySelector("[data-back-to-search]");
    if (backBtn) {
      var newBackBtn = backBtn.cloneNode(true);
      backBtn.parentNode.replaceChild(newBackBtn, backBtn);
      newBackBtn.addEventListener("click", function(e) {
        e.preventDefault();
        clearOpenDiamondUrl();
        showDiamondSearchLayout();
        loadDiamonds(false);
        updateResultMeta();

        setTimeout(function() {
          var root = getRoot();
          if (!root) return;
          var rect = root.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({ top: rect.top + scrollTop - 150, behavior: "smooth" });
        }, 100);
      });
    }

    bindDiamondShareButton(detailView, item);

    // Hide search components and display details view
    var root = getRoot();
    if (root) {
      hideDiamondSearchLayout(root);
    }

    detailView.style.display = "block";
    scheduleDetailMediaRender();
    bindDetailMediaResize();
    loadDiamondAlternatives(item);

    if (root) {
      // Scroll to Step 2 top
      setTimeout(function() {
        var rect = root.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo({ top: rect.top + scrollTop - 150, behavior: "smooth" });
      }, 100);
    }
  }

  function bindEvents() {
    var root = getRoot();
    if (!root || root.dataset.bound === "true") return;
    root.dataset.bound = "true";

    if (!document.documentElement.dataset.rbSettingShapeListener) {
      document.documentElement.dataset.rbSettingShapeListener = "true";
      document.addEventListener("ring-builder:setting-selected", function () {
        if (isStandaloneDiamondBrowse()) return;
        applySettingShapeFromSelection(true);
        updateSearchTitle();
      });
    }

    window.addEventListener("pageshow", function () {
      var savedFilters = restoreFiltersFromMemory();
      if (savedFilters && getRoot()) applyFiltersToUi(savedFilters);
    });

    window.addEventListener("popstate", function () {
      var panel = root.closest('[data-step-content="diamond"]');
      if (panel && panel.hidden) return;
      cancelScheduledFilterReload();
      var sharedId = getSharedDiamondIdFromUrl();
      if (sharedId) {
        applySharedDiamondToFilters(sharedId);
        hideDiamondSearchLayout(root);
        loadDiamonds(false);
        return;
      }
      state.openDiamondId = "";
      state.pendingSharedOpen = "";
      state.currentDiamond = null;
      setCertNumberFilter("");
      showDiamondSearchLayout(root);
      var savedFilters = restoreFiltersFromMemory();
      if (savedFilters) applyFiltersToUi(savedFilters);
      else clearFilters();
      updateSearchTitle();
      loadDiamonds(false);
    });

    // Accordion Toggle
    var triggers = document.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var content = trigger.nextElementSibling;
        if (content.style.display === 'none' || !content.style.display) {
          content.style.display = 'block';
          trigger.classList.remove('collapsed');
        } else {
          content.style.display = 'none';
          trigger.classList.add('collapsed');
        }
      });
    });

    // Diamond type tabs (sync with Colour White/Fancy toggle)
    root.querySelectorAll('.ring-builder-diamond-type-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var type = btn.getAttribute('data-diamond-type');
        setDiamondType(type);
        updateSearchTitle();
        scheduleFilterReload();
      });
    });

    root.querySelectorAll('[data-colour-mode]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setColourMode(btn.getAttribute('data-colour-mode') || 'white');
        updateSearchTitle();
        scheduleFilterReload();
      });
    });

    root.querySelectorAll("[data-fancy-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        scheduleFilterReload();
      });
    });

    var sortRoot = root.querySelector("[data-diamond-sort]");
    var sortTrigger = root.querySelector("[data-diamond-sort-trigger]");
    if (sortTrigger) {
      sortTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = sortRoot && sortRoot.classList.contains("is-open");
        setSortMenuOpen(!isOpen);
      });
    }
    root.querySelectorAll("[data-diamond-sort-option]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        applySortFilter(btn.getAttribute("data-sort"));
        setSortMenuOpen(false);
        scheduleFilterReload();
      });
    });
    if (!document.documentElement.dataset.rbDiamondSortOutsideClick) {
      document.documentElement.dataset.rbDiamondSortOutsideClick = "true";
      document.addEventListener("click", function (e) {
        var activeRoot = getRoot();
        if (!activeRoot) return;
        var activeSort = activeRoot.querySelector("[data-diamond-sort]");
        if (!activeSort || !activeSort.classList.contains("is-open")) return;
        if (activeSort.contains(e.target)) return;
        setSortMenuOpen(false);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        setSortMenuOpen(false);
      });
    }

    var advancedWrap = root.querySelector('[data-diamond-advanced]');
    var advancedToggle = root.querySelector('[data-diamond-advanced-toggle]');
    var advancedPanel = root.querySelector('[data-diamond-advanced-panel]');
    if (advancedToggle && advancedPanel) {
      advancedToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = !advancedPanel.hidden;
        advancedPanel.hidden = isOpen;
        advancedToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (advancedWrap) advancedWrap.classList.toggle('is-open', !isOpen);
      });
    }

    root.querySelectorAll('[data-diamond-pill-group]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.rb-filter-pill');
        if (!pill || !group.contains(pill)) return;
        e.preventDefault();
        pill.classList.toggle('is-active');
        syncPillHiddenInput(group);
        scheduleFilterReload();
      });
    });

    root.querySelectorAll('[data-diamond-checkbox-group]').forEach(function (group) {
      group.addEventListener('change', function (e) {
        if (!e.target.matches('.rb-filter-checkbox__input')) return;
        syncCheckboxHiddenInput(group);
        scheduleFilterReload();
      });
    });

    root.querySelectorAll('[data-diamond-range]').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-diamond-range');
        var hidden = root.querySelector('[data-diamond-filter="' + key + '"]');
        if (hidden) hidden.value = input.value;

        if (key === 'carat_min' || key === 'carat_max') {
          var caratSlider = root.querySelector('#carat-slider');
          if (caratSlider && caratSlider.noUiSlider) {
            var caratDefaults = getFilterDefaults();
            var min = parseFloat(root.querySelector('[data-diamond-filter="carat_min"]').value);
            var max = parseFloat(root.querySelector('[data-diamond-filter="carat_max"]').value);
            if (!isFinite(min)) min = caratDefaults.caratMin;
            if (!isFinite(max)) max = caratDefaults.caratMax;
            caratSlider.noUiSlider.set([min, max]);
          }
        }

        if (key === 'price_min' || key === 'price_max') {
          var priceSlider = root.querySelector('#price-slider');
          if (priceSlider && priceSlider.noUiSlider) {
            var priceDefaults = getFilterDefaults();
            var pmin = parseFloat(root.querySelector('[data-diamond-filter="price_min"]').value);
            var pmax = parseFloat(root.querySelector('[data-diamond-filter="price_max"]').value);
            if (!isFinite(pmin)) pmin = priceDefaults.priceMin;
            if (!isFinite(pmax)) pmax = priceDefaults.priceMax;
            if (pmin < priceDefaults.priceFloor) pmin = priceDefaults.priceFloor;
            if (pmax > priceDefaults.priceMax) pmax = priceDefaults.priceMax;
            if (pmin > pmax) pmin = pmax;
            priceSlider.noUiSlider.set([pmin, pmax]);
          }
        }

        if (key === 'table_min' || key === 'table_max') {
          var tableSliderEl = root.querySelector('#table-slider');
          if (tableSliderEl && tableSliderEl.noUiSlider) {
            var tmin = parseFloat(root.querySelector('[data-diamond-range="table_min"]').value) || 30;
            var tmax = parseFloat(root.querySelector('[data-diamond-range="table_max"]').value) || 90;
            tableSliderEl.noUiSlider.set([tmin, tmax]);
          }
        }

        if (key === 'depth_min' || key === 'depth_max') {
          var depthSliderEl = root.querySelector('#depth-slider');
          if (depthSliderEl && depthSliderEl.noUiSlider) {
            var dmin = parseFloat(root.querySelector('[data-diamond-range="depth_min"]').value) || 30;
            var dmax = parseFloat(root.querySelector('[data-diamond-range="depth_max"]').value) || 90;
            depthSliderEl.noUiSlider.set([dmin, dmax]);
          }
        }

        if (key === 'ratio_min' || key === 'ratio_max') {
          var ratioSliderEl = root.querySelector('#ratio-slider');
          if (ratioSliderEl && ratioSliderEl.noUiSlider) {
            var rmin = parseFloat(root.querySelector('[data-diamond-range="ratio_min"]').value) || 0.8;
            var rmax = parseFloat(root.querySelector('[data-diamond-range="ratio_max"]').value) || 2.5;
            ratioSliderEl.noUiSlider.set([rmin, rmax]);
          }
        }

        scheduleFilterReload();
      });
    });

    // Shape swatch clicking
    root.querySelectorAll('[data-diamond-shape-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var track = root.querySelector('[data-diamond-shape-track]');
        if (track && track._shapeDragMoved) {
          track._shapeDragMoved = false;
          e.preventDefault();
          return;
        }
        e.preventDefault();
        var shape = btn.getAttribute('data-shape');
        var hiddenInput = root.querySelector('[data-diamond-filter="shape"]');
        if (btn.classList.contains('is-active')) {
          btn.classList.remove('is-active', 'is-selected');
          btn.setAttribute('aria-pressed', 'false');
          var swatchOff = btn.querySelector('.diamond-shape-swatch');
          if (swatchOff) swatchOff.classList.remove('is-active', 'diamond-shape-swatch--current');
          if (hiddenInput) hiddenInput.value = '';
        } else {
          root.querySelectorAll('[data-diamond-shape-swatch]').forEach(function (other) {
            other.classList.remove('is-active', 'is-selected');
            other.setAttribute('aria-pressed', 'false');
            var swatch = other.querySelector('.diamond-shape-swatch');
            if (swatch) swatch.classList.remove('is-active', 'diamond-shape-swatch--current');
          });
          btn.classList.add('is-active', 'is-selected');
          btn.setAttribute('aria-pressed', 'true');
          var swatchOn = btn.querySelector('.diamond-shape-swatch');
          if (swatchOn) swatchOn.classList.add('is-active', 'diamond-shape-swatch--current');
          if (hiddenInput) hiddenInput.value = shape;
        }
        updateSearchTitle();
        scheduleFilterReload();
      });
    });

    // Report search button — reset browse filters so a narrow price/polish
    // range cannot hide the exact certificate match (Nivoda treats report
    // search as an exclusive lookup).
    var certSearchBtn = root.querySelector('#diamond-btn-search-cert');
    var certInput = root.querySelector('#diamond-filter-cert-number');
    if (certSearchBtn) {
      certSearchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var certValue = certInput ? String(certInput.value || '').trim() : '';
        if (certValue) {
          clearFilters();
          if (certInput) certInput.value = certValue;
        }
        updateSearchTitle();
        flushFilterReload();
      });
    }
    if (certInput) {
      certInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var certValue = String(certInput.value || '').trim();
          if (certValue) {
            clearFilters();
            certInput.value = certValue;
          }
          updateSearchTitle();
          flushFilterReload();
        }
      });
    }

    // Reset filters button
    var resetBtn = root.querySelector('#diamond-btn-clear-filters');
    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearFilters();
        updateSearchTitle();
        flushFilterReload();
      });
    }

    var hideFiltersBtn = root.querySelector('[data-diamond-hide-filters]');
    var filtersWrap = root.querySelector('.ring-builder-diamonds__filters-wrap');
    if (hideFiltersBtn && filtersWrap) {
      hideFiltersBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var collapsed = filtersWrap.classList.toggle('is-collapsed');
        hideFiltersBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        hideFiltersBtn.innerHTML = collapsed
          ? 'Show Filters'
          : 'Hide Filters <span aria-hidden="true">×</span>';
      });
    }

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var target = event.target;
      
      // If it's a table row, open preview
      var tableRow = target.closest("tr[data-diamond-card]");
      if (tableRow) {
        event.preventDefault();
        var payload = tableRow.getAttribute("data-diamond-payload");
        if (payload) {
          try {
            var item = JSON.parse(payload);
            openDiamondPreview(item);
          } catch(e) {}
        }
        return;
      }
      
      // If it's a direct CTA, click it
      var selectBtn = target.closest("[data-diamond-select]");
      if (!selectBtn || !root.contains(selectBtn)) return;
      event.preventDefault();
      selectBtn.click();
    });

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-diamond-load-more]")) {
        event.preventDefault();
        loadDiamonds(true);
        return;
      }

      var viewBtn = event.target.closest("[data-diamond-view]");
      if (viewBtn) {
        event.preventDefault();
        setViewMode(viewBtn.getAttribute("data-diamond-view"));
        return;
      }

      // Check if they clicked a table row (which has data-offer-id and is a row)
      var tableRow = event.target.closest("tr[data-diamond-card]");
      if (tableRow) {
        event.preventDefault();
        event.stopPropagation();
        var payload = tableRow.getAttribute("data-diamond-payload");
        if (payload) {
          var item;
          try {
            item = JSON.parse(payload);
          } catch (e) {
            return;
          }
          openDiamondPreview(item);
        }
        return;
      }

      // Check if they clicked anywhere else on a grid card
      var gridCard = event.target.closest("li[data-diamond-card]");
      if (gridCard) {
        event.preventDefault();
        event.stopPropagation();
        var cta = gridCard.querySelector("[data-diamond-select]");
        var payload = cta ? cta.getAttribute("data-diamond-payload") : null;
        if (payload) {
          var item;
          try {
            item = JSON.parse(payload);
          } catch (e) {
            return;
          }
          openDiamondPreview(item);
        }
        return;
      }
    });
  }

  function initShapeSlider() {
    var root = getRoot();
    if (!root) return;

    root.querySelectorAll("[data-diamond-shape-slider]").forEach(function (slider) {
      if (slider.dataset.shapeSliderInit === "true") return;
      slider.dataset.shapeSliderInit = "true";

      var track = slider.querySelector("[data-diamond-shape-track]");
      var prevBtn = slider.querySelector("[data-diamond-shape-prev]");
      var nextBtn = slider.querySelector("[data-diamond-shape-next]");
      if (!track) return;

      function updateNav() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var slop = 2;
        var canScroll = maxScroll > slop;

        if (prevBtn) {
          prevBtn.hidden = !canScroll;
          prevBtn.disabled = !canScroll || track.scrollLeft <= slop;
        }
        if (nextBtn) {
          nextBtn.hidden = !canScroll;
          nextBtn.disabled = !canScroll || track.scrollLeft >= maxScroll - slop;
        }
      }

      function scrollByDirection(dir) {
        var amount = Math.max(track.clientWidth * 0.75, 120);
        track.scrollBy({ left: dir * amount, behavior: "smooth" });
      }

      function bindTrackDragScroll() {
        var dragState = null;
        var dragThreshold = 8;

        function onPointerMove(e) {
          if (!dragState) return;
          var dx = e.clientX - dragState.startX;
          if (!dragState.active) {
            if (Math.abs(dx) < dragThreshold) return;
            dragState.active = true;
            track.classList.add("is-dragging");
          }
          track.scrollLeft = dragState.startScrollLeft - dx;
          dragState.moved = true;
        }

        function endPointerDrag() {
          window.removeEventListener("pointermove", onPointerMove);
          window.removeEventListener("pointerup", endPointerDrag);
          window.removeEventListener("pointercancel", endPointerDrag);
          if (!dragState) return;
          if (dragState.moved) track._shapeDragMoved = true;
          track.classList.remove("is-dragging");
          dragState = null;
          updateNav();
        }

        track.addEventListener("pointerdown", function (e) {
          if (e.pointerType === "touch") return;
          if (e.button !== 0) return;
          dragState = {
            startX: e.clientX,
            startScrollLeft: track.scrollLeft,
            active: false,
            moved: false,
          };
          window.addEventListener("pointermove", onPointerMove);
          window.addEventListener("pointerup", endPointerDrag);
          window.addEventListener("pointercancel", endPointerDrag);
        });
      }

      bindTrackDragScroll();

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          scrollByDirection(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          scrollByDirection(1);
        });
      }

      track.addEventListener("scroll", updateNav, { passive: true });
      if (typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(updateNav);
        resizeObserver.observe(track);
      } else {
        window.addEventListener("resize", updateNav);
      }
      updateNav();
    });
  }

  function initStep2() {
    var root = getRoot();
    if (!root) return;

    var sharedIdOnLoad = getSharedDiamondIdFromUrl();
    if (sharedIdOnLoad) {
      state.openDiamondId = sharedIdOnLoad;
      hideDiamondSearchLayout(root);
    } else {
      showDiamondSearchLayout(root);
    }
    updateLoadingUi(true, false);

    bindEvents();
    initSliders();
    initShapeSlider();

    loadFancyFilterOptions().finally(function () {
      try {
        // Do not overwrite in-progress multi-selects with a stale URL snapshot.
        if (root.dataset.filtersBootstrapped !== "true" && !state.userHasEditedFilters) {
          restoreViewMode();
          var savedFilters = restoreFiltersFromMemory();
          if (savedFilters) applyFiltersToUi(savedFilters);
          else {
            clearFilters();
            applySortFilter(getDefaultDiamondSort());
          }
          root.dataset.filtersBootstrapped = "true";
        }

        applySettingShapeDefaultIfNeeded();
        updateSearchTitle();
        setPanelMessage("");
        if (sharedIdOnLoad) applySharedDiamondToFilters(sharedIdOnLoad);
        flushFilterReload();
      } catch (bootError) {
        setLoading(false);
        setPanelMessage(
          (bootError && bootError.message) ||
            "Unable to start diamond search. Hard-refresh the page and try again.",
          true,
        );
      }
    });
  }

  function clearSavedDiamond() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function getProductSyncBaseUrl() {
    var el = document.querySelector("[data-nivoda-product-sync-base]");
    var base = el
      ? (el.getAttribute("data-nivoda-product-sync-base") || "").replace(/\/+$/, "")
      : "";

    // External browse API — product creation still uses live Nivoda proxy on the store.
    if (/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(base)) {
      return NIVODA_LIVE_PROXY_BASE;
    }

    return base || NIVODA_LIVE_PROXY_BASE;
  }

  function getProxyBaseUrl() {
    var mainCollection = document.querySelector("[data-nivoda-proxy-base]");
    if (mainCollection) {
      return (
        mainCollection.getAttribute("data-nivoda-proxy-base") || ""
      ).replace(/\/+$/, "");
    }
    var config = getConfig();
    return String(config.proxyUrl || "").replace(/\/(diamonds|gemstones)\/?$/, "");
  }

  function buildCertificateUrl(diamond) {
    var cert = String(diamond.certNumber || diamond.offerId || "").trim();
    if (!cert) return "";
    var lab = String(diamond.lab || "").toUpperCase();
    if (lab === "GIA") {
      return (
        "https://www.gia.edu/report-check?reportno=" +
        encodeURIComponent(cert)
      );
    }
    if (lab === "IGI") {
      return "https://www.igi.org/verify.php?r=" + encodeURIComponent(cert);
    }
    return "";
  }

  function buildCertificateLabel(item) {
    var lab = String(item.lab || "IGI").trim().toUpperCase();
    var cert = String(item.certNumber || "").trim();
    if (cert) return lab + " #" + cert;
    return lab + " CERTIFIED";
  }

  function appendCertificateThumbButton(mediaThumbs, item) {
    if (!mediaThumbs || !item) return;

    var certUrl = buildCertificateUrl(item);
    if (!certUrl) return;

    var certBtn = document.createElement("a");
    certBtn.href = certUrl;
    certBtn.target = "_blank";
    certBtn.rel = "noopener noreferrer";
    certBtn.className = "diamond-detail-view__media-thumb--certificate";
    certBtn.textContent = "View Certificate";
    certBtn.setAttribute("aria-label", "View " + buildCertificateLabel(item));
    mediaThumbs.appendChild(certBtn);
  }

  function populateDetailLabBadgeLink(detailView, item) {
    if (!detailView || !item) return;

    var certUrl = buildCertificateUrl(item);
    var labBadgeEl = detailView.querySelector("[data-detail-lab-badge]");
    if (!labBadgeEl) return;

    labBadgeEl.textContent = (item.lab || "IGI") + " CERTIFIED";
    if (certUrl) {
      labBadgeEl.href = certUrl;
      labBadgeEl.target = "_blank";
      labBadgeEl.rel = "noopener noreferrer";
      labBadgeEl.classList.remove("diamond-lab-badge--static");
      labBadgeEl.removeAttribute("aria-disabled");
    } else {
      labBadgeEl.removeAttribute("href");
      labBadgeEl.removeAttribute("target");
      labBadgeEl.removeAttribute("rel");
      labBadgeEl.classList.add("diamond-lab-badge--static");
      labBadgeEl.setAttribute("aria-disabled", "true");
    }
  }

  function buildDiamondCartProperties(diamond, builderId) {
    var cert = String(diamond.certNumber || diamond.offerId || "").trim();
    var lab = String(diamond.lab || "IGI").toUpperCase();
    var stoneType =
      diamond.labgrown === true || diamond.labgrown === "true"
        ? "Lab Grown Diamonds"
        : "Natural Diamonds";
    var props = {
      "Diamond Certificate": cert,
      stock_no: diamond.offerId || diamond.diamondId || "",
      stone_shape: formatShapeLabel(diamond.shape),
      laboratory: lab,
      carat_weight: diamond.carats != null ? String(diamond.carats) : "",
      clarity: diamond.clarity || "",
      color: diamond.color || "",
      stone_type: stoneType,
      cut: formatCutLabel(diamond.cut),
      _price: String(diamond.price != null ? diamond.price : ""),
    };
    if (builderId) props._builder_id = builderId;
    return props;
  }

  function parseProxyJsonResponse(response) {
    return response.text().then(function (text) {
      var payload = {};
      var trimmed = (text || "").trim();

      if (trimmed) {
        if (trimmed.charAt(0) === "<") {
          throw new Error(
            "Nivoda app proxy is unavailable (received HTML instead of JSON). Restart nivoda-product-sync/start-dev.ps1, open the install URL it prints, then hard-refresh this page.",
          );
        }
        try {
          payload = JSON.parse(trimmed);
        } catch (parseError) {
          throw new Error(
            "Nivoda app proxy returned an invalid response. Restart start-dev.ps1, reinstall the app on this store, then hard-refresh the ring builder page.",
          );
        }
      }

      if (response.status === 511) {
        throw new Error(
          "Tunnel blocked the request (511). Restart nivoda-product-sync/start-dev.ps1 and use the new Cloudflare tunnel URL.",
        );
      }
      if (response.status === 500) {
        throw new Error(
          "Proxy request failed (500). The Nivoda app tunnel may be down — restart nivoda-product-sync/start-dev.ps1, then refresh this page.",
        );
      }
      if (!response.ok) {
        var errMsg =
          (payload && payload.error) ||
          "Proxy request failed (" + response.status + ").";
        if (payload && payload.fallback) {
          errMsg = "Shopify Admin API is not configured for diamond product sync.";
        }
        throw new Error(errMsg);
      }

      return payload;
    });
  }

  function ensureDiamondForCart(diamond, builderId) {
    var proxyBase = getProductSyncBaseUrl();
    if (!proxyBase) {
      return Promise.reject(new Error("Nivoda proxy URL is not configured."));
    }

    return fetch(proxyBase + "/diamond/ensure-product", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        diamond: diamond,
        builder_id: builderId || "",
        margin:
          window.RingBuilderDiamondMargin &&
          typeof window.RingBuilderDiamondMargin.getMarginPayload === "function"
            ? window.RingBuilderDiamondMargin.getMarginPayload()
            : undefined,
      }),
    }).then(function (response) {
      return parseProxyJsonResponse(response).then(function (payload) {
        if (payload.variantId) {
          try {
            var saved = Object.assign({}, diamond, {
              shopifyVariantId: payload.variantId,
              shopifyProductTitle: payload.productTitle || "",
            });
            localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
          } catch (e) {}
        }
        return payload;
      });
    });
  }

  function addItemsToCart(items) {
    return fetch("/cart/add.js?_fd=0", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = {};
        if (text) {
          try {
            payload = JSON.parse(text);
          } catch (e) {}
        }
        if (!response.ok) {
          throw new Error(
            (payload && (payload.description || payload.message)) ||
              "Failed to add items to cart.",
          );
        }
        return payload;
      });
    });
  }

  function addDiamondLineToCart(diamond, builderId, button, originalText) {
    return ensureDiamondForCart(diamond, builderId)
      .then(function (ensureResult) {
        var properties = ensureResult.properties || buildDiamondCartProperties(diamond, builderId);
        if (ensureResult.productId && !properties._product_id) {
          properties._product_id = String(ensureResult.productId);
        }
        return addItemsToCart([
          {
            id: parseInt(ensureResult.variantId, 10),
            quantity: 1,
            properties: properties,
          },
        ]).then(function () {
          if (window.RingBuilderCartCleanup && ensureResult.productId) {
            window.RingBuilderCartCleanup.trackProductId(ensureResult.productId);
          }
        });
      })
      .catch(function (error) {
        var mainContainer = document.querySelector(
          "[data-placeholder-diamond-variant-id]",
        );
        var placeholderDiamondVariantId = mainContainer
          ? mainContainer.getAttribute("data-placeholder-diamond-variant-id")
          : null;
        if (!placeholderDiamondVariantId) throw error;
        return addItemsToCart([
          {
            id: parseInt(placeholderDiamondVariantId, 10),
            quantity: 1,
            properties: buildDiamondCartProperties(diamond, builderId),
          },
        ]);
      })
      .then(function () {
        window.location.href = "/cart?_fd=0";
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
        alert("Failed to add loose diamond to cart.");
      });
  }

  return {
    initStep2: initStep2,
    loadDiamonds: loadDiamonds,
    getSavedDiamond: getSavedDiamond,
    clearSavedDiamond: clearSavedDiamond,
    hasSelectedSetting: hasSelectedSetting,
    getFlow: getFlow,
    isDiamondFirst: isDiamondFirst,
    buildDiamondCartProperties: buildDiamondCartProperties,
    ensureDiamondForCart: ensureDiamondForCart,
    addDiamondLineToCart: addDiamondLineToCart,
  };
})();
